function mgSelectText(el) {
  if (!el) return "";
  try {
    el.hidden = false;
  } catch (_) { }
  try {
    el.focus({ preventScroll: false });
  } catch (_) {
    try { el.focus(); } catch (_) { }
  }
  try {
    el.removeAttribute("readonly");
  } catch (_) { }
  try {
    el.select();
  } catch (_) { }
  try {
    el.setSelectionRange(0, String(el.value || "").length);
  } catch (_) { }
  try {
    el.setAttribute("readonly", "readonly");
  } catch (_) { }
  return String(el.value || "");
}

async function mgSelectAndCopyText(el) {
  const text = mgSelectText(el);
  if (!text) return false;
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (_) { }
  try {
    return !!document.execCommand("copy");
  } catch (_) { }
  return false;
}

(() => {
  "use strict";

  const MGPS_DEBUG_BUILD = "2026-04-11b";

  const R = window.__MGProductSwatchesRuntime || (window.__MGProductSwatchesRuntime = {});
  if (R.__installed) {
    try {
      if (typeof R.refresh === "function") {
        const cs = document.currentScript;
        const ctx = cs && cs.closest ? cs.closest(".shopify-section") : null;
        R.refresh(ctx || document);
      }
    } catch (_) { }
    return;
  }
  R.__installed = true;
  R.__rawSpecs = R.__rawSpecs || Object.create(null);

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn, { once: true });
    else fn();
  }

  const mgpsPreloadedPopupImageSrcs = new Set();
  const mgpsQueuedPopupImageSrcs = new Set();
  let mgpsPopupPreloadStarted = false;

  function popupItemImageSrc(meta) {
    const baseSrc = rawImageSrc(meta?.thumbnail || meta?.image || meta?.img || "");
    if (!baseSrc) return "";
    try {
      return cappedShopifyImageUrl(baseSrc, 2400, 1200);
    } catch (_) {
      return baseSrc;
    }
  }

  function flushPopupImagePreloadQueue() {
    if (mgpsPopupPreloadStarted) return;
    mgpsPopupPreloadStarted = true;
    const sources = Array.from(mgpsQueuedPopupImageSrcs);
    sources.forEach((src) => {
      if (!src || mgpsPreloadedPopupImageSrcs.has(src)) return;
      mgpsPreloadedPopupImageSrcs.add(src);
      try {
        const img = new Image();
        try { img.fetchPriority = "high"; } catch (_) { }
        img.decoding = "async";
        img.src = src;
      } catch (_) { }
    });
  }

  function queuePopupImagePreload(items) {
    const arr = Array.isArray(items) ? items : [];
    arr.forEach((meta) => {
      const src = popupItemImageSrc(meta);
      if (src) mgpsQueuedPopupImageSrcs.add(src);
    });
    ready(() => {
      try {
        if ("requestIdleCallback" in window) {
          window.requestIdleCallback(() => flushPopupImagePreloadQueue(), { timeout: 1200 });
        } else {
          setTimeout(() => flushPopupImagePreloadQueue(), 120);
        }
      } catch (_) {
        flushPopupImagePreloadQueue();
      }
    });
  }

  function safeJsonParse(text) {
    try { return JSON.parse(text); } catch (_) { return null; }
  }

  function setStyleImportant(el, prop, value) {
    if (!el) return;
    try {
      if (value == null || value === "") el.style.removeProperty(prop);
      else el.style.setProperty(prop, String(value), "important");
    } catch (_) { }
  }

  function getDataAttr(root, name) {
    try {
      if (!root || !root.getAttribute) return "";
      return String(root.getAttribute(name) || "").trim();
    } catch (_) {
      return "";
    }
  }

  function isNonEmptyObject(value) {
    return !!(value && typeof value === "object" && !Array.isArray(value) && Object.keys(value).length);
  }

  function appearanceHasVisualOverrides(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    const keys = [
      "border_color",
      "borderColor",
      "border_size",
      "borderSize",
      "background_color",
      "backgroundColor",
      "background_image",
      "backgroundImage",
      "background_image_style",
      "backgroundImageStyle",
      "product_image_padding",
      "productImagePadding",
      "border_scope",
      "borderScope",
      "shadow_size",
      "shadowSize",
      "corner_radius_px",
      "cornerRadiusPx",
      "border_radius_px",
      "borderRadiusPx",
      "image_radius_px",
      "imageRadiusPx",
      "gradient_color",
      "gradientColor",
      "gradient_angle",
      "gradientAngle",
      "text_color",
      "textColor",
      "text_size_mobile",
      "textSizeMobile",
      "text_size_desktop",
      "textSizeDesktop",
      "text_style",
      "textStyle",
      "selected_text_style",
      "selectedTextStyle"
    ];
    return keys.some((key) => Object.prototype.hasOwnProperty.call(value, key) && value[key] !== null && value[key] !== "");
  }

  function rootHasExplicitAppearance(root) {
    try {
      const appearanceJson = safeJsonParse(getDataAttr(root, "data-mgps-appearance") || "{}") || {};
      const selectedJson = safeJsonParse(getDataAttr(root, "data-mgps-selected-appearance") || "{}") || {};
      if (appearanceHasVisualOverrides(appearanceJson) || appearanceHasVisualOverrides(selectedJson)) return true;
      const attrs = [
        "data-mgps-border-color",
        "data-mgps-border-size",
        "data-mgps-background-color",
        "data-mgps-background-image",
        "data-mgps-background-image-style",
        "data-mgps-product-image-padding",
        "data-mgps-border-scope",
        "data-mgps-selected-border-color",
        "data-mgps-selected-border-size",
        "data-mgps-selected-border-scope",
        "data-mgps-selected-background-color",
        "data-mgps-selected-background-image",
        "data-mgps-selected-background-image-style",
        "data-mgps-selected-product-image-padding",
        "data-mgps-corner-radius"
      ];
      return attrs.some((name) => getDataAttr(root, name) !== "");
    } catch (_) {
      return false;
    }
  }

  function collapseWhitespace(value) {
    return String(value == null ? "" : value).replace(/\s+/g, " ").trim();
  }

  function isDebugTextFitEnabled() {
    try {
      const params = new URLSearchParams(window.location.search || "");
      const value = String(params.get("mgps_debug_text_fit") || "").trim().toLowerCase();
      return value === "1" || value === "true" || value === "yes" || value === "on";
    } catch (_) {
      return false;
    }
  }

  function appearanceHasExplicitBorderOverrides(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    const keys = [
      "border_color",
      "borderColor",
      "border_size",
      "borderSize",
      "border_scope",
      "borderScope",
      "shadow_size",
      "shadowSize",
      "corner_radius_px",
      "cornerRadiusPx",
      "border_radius_px",
      "borderRadiusPx",
      "image_radius_px",
      "imageRadiusPx"
    ];
    return keys.some((key) => Object.prototype.hasOwnProperty.call(value, key) && value[key] !== null && value[key] !== "");
  }

  function rootHasExplicitBorderAppearance(root) {
    try {
      const appearanceJson = safeJsonParse(getDataAttr(root, "data-mgps-appearance") || "{}") || {};
      const selectedJson = safeJsonParse(getDataAttr(root, "data-mgps-selected-appearance") || "{}") || {};
      if (appearanceHasExplicitBorderOverrides(appearanceJson) || appearanceHasExplicitBorderOverrides(selectedJson)) return true;
      const attrs = [
        "data-mgps-border-color",
        "data-mgps-border-size",
        "data-mgps-border-scope",
        "data-mgps-selected-border-color",
        "data-mgps-selected-border-size",
        "data-mgps-selected-border-scope",
        "data-mgps-border-radius",
        "data-mgps-image-radius",
        "data-mgps-corner-radius"
      ];
      return attrs.some((name) => getDataAttr(root, name) !== "");
    } catch (_) {
      return false;
    }
  }

  function rootTextBehaviorOverride(root) {
    const raw = getDataAttr(root, "data-mgps-text-behavior");
    const normalized = String(raw || "").trim().toLowerCase();
    if (!normalized || normalized === "wrap_text") return "";
    return normalized;
  }

  function textContentExcludingNode(el, excludedNode) {
    if (!el) return "";
    try {
      return collapseWhitespace(Array.from(el.childNodes || [])
        .filter((node) => node && node !== excludedNode)
        .map((node) => String(node.textContent || ""))
        .join(" "));
    } catch (_) {
      return collapseWhitespace(String(el.textContent || ""));
    }
  }

  function measuredTextWidth(text, sourceEl) {
    const content = collapseWhitespace(text);
    if (!content || !sourceEl || !document.body) return 0;
    try {
      const probe = document.createElement("span");
      const computed = window.getComputedStyle ? window.getComputedStyle(sourceEl) : null;
      probe.textContent = content;
      probe.style.position = "fixed";
      probe.style.left = "-99999px";
      probe.style.top = "0";
      probe.style.visibility = "hidden";
      probe.style.pointerEvents = "none";
      probe.style.display = "inline-block";
      probe.style.width = "auto";
      probe.style.minWidth = "0";
      probe.style.maxWidth = "none";
      probe.style.margin = "0";
      probe.style.padding = "0";
      probe.style.border = "0";
      probe.style.whiteSpace = "nowrap";
      probe.style.wordBreak = "normal";
      probe.style.overflowWrap = "normal";
      probe.style.textTransform = "none";
      probe.style.transform = "none";
      probe.style.letterSpacing = "normal";
      if (computed) {
        probe.style.font = computed.font;
        probe.style.fontFamily = computed.fontFamily;
        probe.style.fontSize = computed.fontSize;
        probe.style.fontStyle = computed.fontStyle;
        probe.style.fontWeight = computed.fontWeight;
        probe.style.fontStretch = computed.fontStretch;
        probe.style.fontKerning = computed.fontKerning;
        probe.style.fontVariantLigatures = computed.fontVariantLigatures;
        probe.style.lineHeight = computed.lineHeight;
        probe.style.textTransform = computed.textTransform;
        probe.style.wordSpacing = computed.wordSpacing;
      }
      document.body.appendChild(probe);
      const width = Math.ceil(probe.getBoundingClientRect().width || probe.scrollWidth || probe.offsetWidth || 0);
      probe.remove();
      return width;
    } catch (_) {
      return 0;
    }
  }

  function squeezeLetterSpacingEm(scaleX) {
    const scale = clampNumber(scaleX, 0.4, 1, 1);
    if (scale >= 0.999) return "normal";
    const deficit = 1 - scale;
    const spacing = Math.max(-0.035, Math.min(-0.008, -(deficit * 0.42)));
    return spacing.toFixed(3) + "em";
  }

  function squeezeVisualReservePx(el) {
    if (!el) return 10;
    try {
      const computed = window.getComputedStyle ? window.getComputedStyle(el) : null;
      const fontSize = computed ? (parseFloat(computed.fontSize || "0") || 0) : 0;
      return Math.max(8, Math.min(12, Math.round(fontSize * 0.9) || 10));
    } catch (_) {
      return 10;
    }
  }

  function unwrapFittedTextInner(el) {
    if (!el || !el.querySelector) return;
    try {
      const inner = el.querySelector(':scope > [data-mgps-fit-text]');
      if (!inner) return;
      const sourceText = collapseWhitespace(inner.textContent || textContentExcludingNode(el, inner) || el.textContent || "");
      if (sourceText) el.textContent = sourceText;
      else inner.remove();
    } catch (_) { }
  }

  function ensureFittedTextInner(el, text) {
    if (!el || !document.createElement) return null;
    try {
      let inner = el.querySelector(':scope > [data-mgps-fit-text]');
      if (!inner) {
        inner = document.createElement("span");
        inner.setAttribute("data-mgps-fit-text", "true");
        while (el.firstChild) inner.appendChild(el.firstChild);
        el.appendChild(inner);
      }
      inner.textContent = text;
      return inner;
    } catch (_) {
      return null;
    }
  }

  function applySqueezedTextFit(el, enabled) {
    if (!el) return;
    try {
      unwrapFittedTextInner(el);
      const baseFontSize = (() => {
        const raw = el.dataset.mgpsBaseFontSize || "";
        if (raw) return raw;
        const computed = window.getComputedStyle ? window.getComputedStyle(el) : null;
        const value = computed ? String(computed.fontSize || "") : "";
        return value || "";
      })();
      const baseLineHeight = (() => {
        const raw = el.dataset.mgpsBaseLineHeight || "";
        if (raw) return raw;
        const computed = window.getComputedStyle ? window.getComputedStyle(el) : null;
        const value = computed ? String(computed.lineHeight || "") : "";
        return value || "";
      })();

      try {
        if (baseFontSize) el.dataset.mgpsBaseFontSize = baseFontSize;
        if (baseLineHeight) el.dataset.mgpsBaseLineHeight = baseLineHeight;
      } catch (_) { }

      if (!enabled) {
        unwrapFittedTextInner(el);
        setStyleImportant(el, "transform-origin", "center center");
        setStyleImportant(el, "display", "block");
        setStyleImportant(el, "width", "100%");
        setStyleImportant(el, "max-width", "100%");
        setStyleImportant(el, "margin", "0");
        setStyleImportant(el, "justify-self", "");
        setStyleImportant(el, "align-self", "center");
        setStyleImportant(el, "text-align", "center");
        setStyleImportant(el, "letter-spacing", "normal");
        setStyleImportant(el, "font-size", baseFontSize || "");
        setStyleImportant(el, "line-height", baseLineHeight || "");
        setStyleImportant(el, "transform", "none");
        try {
          el.dataset.mgpsFitEnabled = "false";
          el.dataset.mgpsFitApplied = "false";
          el.dataset.mgpsFitScale = "1";
          el.dataset.mgpsFitNaturalWidth = "0";
          el.dataset.mgpsFitAvailableWidth = String(Math.floor(el.clientWidth || el.getBoundingClientRect().width || 0) || 0);
        } catch (_) { }
        return;
      }
      const measuredAvailableWidth = Math.floor(
        (el.parentElement && (el.parentElement.clientWidth || (el.parentElement.getBoundingClientRect && el.parentElement.getBoundingClientRect().width) || 0))
        || el.clientWidth
        || el.getBoundingClientRect().width
        || 0
      );
      const availableWidth = Math.max(0, measuredAvailableWidth - squeezeVisualReservePx(el));
      setStyleImportant(el, "display", "block");
      setStyleImportant(el, "width", "100%");
      setStyleImportant(el, "max-width", "100%");
      setStyleImportant(el, "margin", "0");
      setStyleImportant(el, "justify-self", "");
      setStyleImportant(el, "align-self", "center");
      setStyleImportant(el, "transform-origin", "center center");
      setStyleImportant(el, "text-align", "center");
      setStyleImportant(el, "white-space", "nowrap");
      setStyleImportant(el, "overflow", "visible");
      const text = collapseWhitespace(el.textContent || "");
      if (!text || !(availableWidth > 0)) {
        setStyleImportant(el, "display", "block");
        setStyleImportant(el, "width", "100%");
        setStyleImportant(el, "max-width", "100%");
        setStyleImportant(el, "margin", "0");
        setStyleImportant(el, "justify-self", "");
        setStyleImportant(el, "align-self", "center");
        setStyleImportant(el, "text-align", "center");
        setStyleImportant(el, "letter-spacing", "normal");
        setStyleImportant(el, "font-size", baseFontSize || "");
        setStyleImportant(el, "line-height", baseLineHeight || "");
        setStyleImportant(el, "transform", "none");
        setStyleImportant(el, "overflow", "visible");
        const emptyInner = ensureFittedTextInner(el, "");
        if (emptyInner) {
          setStyleImportant(emptyInner, "display", "inline-block");
          setStyleImportant(emptyInner, "margin", "0");
          setStyleImportant(emptyInner, "transform-origin", "left center");
          setStyleImportant(emptyInner, "letter-spacing", "normal");
          setStyleImportant(emptyInner, "transform", "none");
        }
        try {
          el.dataset.mgpsFitEnabled = "true";
          el.dataset.mgpsFitApplied = "false";
          el.dataset.mgpsFitScale = "1";
          el.dataset.mgpsFitNaturalWidth = "0";
          el.dataset.mgpsFitAvailableWidth = String(availableWidth || 0);
        } catch (_) { }
        return;
      }

      const naturalWidth = measuredTextWidth(text, el);
      const scaleX = naturalWidth > 0 && availableWidth > 0
        ? Math.max(0.4, Math.min(1, availableWidth / naturalWidth))
        : 1;
      const inner = ensureFittedTextInner(el, text);
      setStyleImportant(el, "margin", "0");
      setStyleImportant(el, "justify-self", "");
      setStyleImportant(el, "align-self", "center");
      setStyleImportant(el, "text-align", "center");
      setStyleImportant(el, "font-size", baseFontSize || "");
      setStyleImportant(el, "line-height", baseLineHeight || "");
      setStyleImportant(el, "transform", "none");
      setStyleImportant(el, "overflow", "visible");
      if (inner) {
        setStyleImportant(inner, "display", "inline-block");
        setStyleImportant(inner, "margin", "0");
        setStyleImportant(inner, "transform-origin", "left center");
        setStyleImportant(inner, "vertical-align", "top");
        setStyleImportant(inner, "letter-spacing", squeezeLetterSpacingEm(scaleX));
        setStyleImportant(inner, "transform", scaleX < 0.999 ? ("scaleX(" + scaleX.toFixed(3) + ")") : "none");
      }
      try {
        el.dataset.mgpsFitEnabled = "true";
        el.dataset.mgpsFitApplied = scaleX < 0.999 ? "true" : "false";
        el.dataset.mgpsFitScale = scaleX.toFixed(3);
        el.dataset.mgpsFitNaturalWidth = String(naturalWidth || 0);
        el.dataset.mgpsFitAvailableWidth = String(availableWidth || 0);
      } catch (_) { }
    } catch (_) { }
  }

  function updateTextFitDebugCard(card, textBehavior) {
    if (!card) return;
    try {
      let badge = card.querySelector(":scope > .mgps-debug-text-fit");
      if (!isDebugTextFitEnabled()) {
        if (badge) badge.remove();
        return;
      }

      const titleEl = card.querySelector(".mgps-title");
      const scale = titleEl ? String(titleEl.dataset.mgpsFitScale || "") : "";
      const applied = titleEl ? String(titleEl.dataset.mgpsFitApplied || "") : "";
      const natural = titleEl ? String(titleEl.dataset.mgpsFitNaturalWidth || "") : "";
      const available = titleEl ? String(titleEl.dataset.mgpsFitAvailableWidth || "") : "";

      if (!badge) {
        badge = document.createElement("div");
        badge.className = "mgps-debug-text-fit";
        badge.style.position = "absolute";
        badge.style.top = "4px";
        badge.style.left = "4px";
        badge.style.zIndex = "30";
        badge.style.maxWidth = "calc(100% - 8px)";
        badge.style.padding = "4px 6px";
        badge.style.background = "rgba(0,0,0,0.78)";
        badge.style.color = "#fff";
        badge.style.font = "11px/1.2 monospace";
        badge.style.borderRadius = "4px";
        badge.style.pointerEvents = "none";
        badge.style.whiteSpace = "pre-wrap";
        card.appendChild(badge);
      }

      badge.textContent = [
        "behavior=" + String(textBehavior || ""),
        "applied=" + applied,
        "scale=" + scale,
        "avail=" + available,
        "natural=" + natural
      ].join(" ");
    } catch (_) { }
  }

  function optimizedShopifySwatchUrl(url, targetWidth) {
    const raw = String(url || "").trim();
    const widthNum = Math.max(1, Math.round(Number(targetWidth) || 0));
    if (!raw) return raw;
    if (!widthNum) return raw;
    if (!/cdn\.shopify\.com/i.test(raw)) return raw;
    try {
      const absolute = raw.startsWith("//") ? ("https:" + raw) : raw;
      const u = new URL(absolute);
      u.searchParams.set("width", String(widthNum));
      const out = u.toString().replace(/^https:/, "");
      return raw.startsWith("//") ? out : out;
    } catch (_) {
      if (/([?&])width=\d+/i.test(raw)) return raw.replace(/([?&])width=\d+/i, "$1width=" + String(widthNum));
      return raw + (raw.includes("?") ? "&" : "?") + "width=" + String(widthNum);
    }
  }

  function currentSwatchRequestWidth(card, slot, imgWrap) {
    const sources = [
      imgWrap && imgWrap.getBoundingClientRect ? imgWrap.getBoundingClientRect().width : 0,
      slot && slot.getBoundingClientRect ? slot.getBoundingClientRect().width : 0,
      card && card.getBoundingClientRect ? card.getBoundingClientRect().width : 0,
      imgWrap && imgWrap.clientWidth ? imgWrap.clientWidth : 0,
      slot && slot.clientWidth ? slot.clientWidth : 0,
      card && card.clientWidth ? card.clientWidth : 0
    ];
    const width = sources.find((v) => Number(v) > 0) || 150;
    // cap swatch image requests to 400px to avoid huge CDN widths
    const capped = Math.min(Number(width) || 0, 400);
    return Math.max(1, Math.round(capped || 150));
  }

  function cappedShopifyImageUrl(url, maxWidth = 2400, fallbackWidth = 400) {
    const raw = String(url || "").trim();
    if (!raw) return raw;
    try {
      const absolute = raw.startsWith("//") ? ("https:" + raw) : raw;
      const u = new URL(absolute);
      if (!/cdn\.shopify\.com/i.test(u.hostname || "")) return raw;
      const existingWidth = Number(u.searchParams.get("width") || 0);
      const targetWidth = existingWidth > 0
        ? Math.min(Math.max(1, Math.round(existingWidth)), maxWidth)
        : Math.min(Math.max(1, Math.round(fallbackWidth)), maxWidth);
      u.searchParams.set("width", String(targetWidth));
      const out = u.toString().replace(/^https:/, "");
      return raw.startsWith("//") ? out : out;
    } catch (_) {
      if (/([?&])width=\d+/i.test(raw)) {
        return raw.replace(/([?&])width=(\d+)/i, (_, prefix, width) => {
          const targetWidth = Math.min(Math.max(1, Number(width) || fallbackWidth), maxWidth);
          return prefix + "width=" + String(targetWidth);
        });
      }
      return optimizedShopifySwatchUrl(raw, Math.min(Math.max(1, fallbackWidth), maxWidth));
    }
  }

  function plainTextFromMaybeHtml(value) {
    try {
      const tpl = document.createElement("template");
      tpl.innerHTML = String(value || "");
      return collapseWhitespace(tpl.content.textContent || "");
    } catch (_) {
      return collapseWhitespace(String(value || "").replace(/<[^>]*>/g, " "));
    }
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function isTrueLike(raw) {
    if (raw === true) return true;
    const s = String(raw == null ? "" : raw).trim().toLowerCase();
    return s === "true" || s === "1" || s === "yes" || s === "on";
  }

  function clampNumber(raw, min, max, fallback) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return fallback;
    return Math.max(min, Math.min(max, n));
  }

  function clampScalePct(raw, min = 1, max = 100, fallback = 100) {
    return Math.round(clampNumber(raw, min, max, fallback));
  }

  function clampImageZoomPct(raw, fallback = 100) {
    return Math.round(clampNumber(raw, 1, 600, fallback));
  }

  function normalizePresetButtonStyle(raw, fallback = "dropdown_box") {
    const base = String(fallback || "dropdown_box").trim().toLowerCase();
    const s = String(raw || "").trim().toLowerCase();
    if (!s) return base;
    const compact = s.replace(/[\s/_-]+/g, "");
    if (compact === "buttonprimary" || compact === "primarybutton" || compact === "primary") return "button_primary";
    if (compact === "buttonsecondary" || compact === "secondarybutton" || compact === "secondary") return "button_secondary";
    if (compact === "button" || compact === "pill") return "button_primary";
    if (compact === "productimagebutton" || compact === "productimage") return "product_image_button";
    if (compact === "imagebutton" || compact === "image" || compact === "imagecard" || compact === "defaultbutton") return "image_button";
    return "dropdown_box";
  }

  function normalizePresetButtonWidthPercent(raw, fallback = 0) {
    return clampNumber(raw, 0, 100, fallback);
  }

  function normalizeBackgroundImageStyle(raw, fallback = "center") {
    const s = String(raw || "").trim().toLowerCase();
    if (s === "stretch_to_fit" || s === "stretch") return "stretch_to_fit";
    if (s === "full_width" || s === "width") return "full_width";
    if (s === "full_height" || s === "height") return "full_height";
    return "center";
  }

  function normalizeBorderScope(raw, fallback = "image") {
    const s = String(raw || "").trim().toLowerCase();
    return s === "image_text" ? "image_text" : (fallback === "image_text" ? "image_text" : "image");
  }

  function normalizeSwatchAppearance(raw, fallbackScope = "image") {
    const obj = raw && typeof raw === "object" ? raw : {};
    const color = collapseWhitespace(obj.border_color ?? obj.borderColor ?? "#000000") || "#000000";
    const bgColor = collapseWhitespace(obj.background_color ?? obj.backgroundColor ?? "") || "transparent";
    return {
      gradient_color: collapseWhitespace(obj.gradient_color ?? obj.gradientColor ?? ""),
      gradient_angle: clampNumber(obj.gradient_angle ?? obj.gradientAngle, 0, 360, 180),
      border_color: color,
      border_size: clampNumber(obj.border_size ?? obj.borderSize, 0, 20, 2),
      background_color: bgColor || "transparent",
      background_image: safeSrc(obj.background_image ?? obj.backgroundImage ?? ""),
      background_image_style: normalizeBackgroundImageStyle(obj.background_image_style ?? obj.backgroundImageStyle, "center"),
      product_image_padding: clampNumber(obj.product_image_padding ?? obj.productImagePadding, 0, 6, 0),
      border_scope: normalizeBorderScope(obj.border_scope ?? obj.borderScope, fallbackScope),
      shadow_size: clampNumber(obj.shadow_size ?? obj.shadowSize, 0, 60, 0),
      border_radius_px: clampNumber(obj.border_radius_px ?? obj.borderRadiusPx ?? obj.corner_radius_px ?? obj.cornerRadiusPx, 0, 240, 12),
      image_radius_px: clampNumber(obj.image_radius_px ?? obj.imageRadiusPx ?? obj.corner_radius_px ?? obj.cornerRadiusPx, 0, 240, 12),
      text_behavior: String(obj.text_behavior ?? obj.textBehavior ?? "wrap_text").trim().toLowerCase() || "wrap_text",
      text_color: collapseWhitespace(obj.text_color ?? obj.textColor ?? "") || "",
      text_size_mobile: clampNumber(obj.text_size_mobile ?? obj.textSizeMobile, 0, 48, 0),
      text_size_desktop: clampNumber(obj.text_size_desktop ?? obj.textSizeDesktop, 0, 48, 0),
      text_style: String(obj.text_style ?? obj.textStyle ?? "").trim().toLowerCase()
    };
  }

  function applyPresetButtonTextFit(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(".mgps-preset-btn__label").forEach((labelEl) => {
      try {
        unwrapFittedTextInner(labelEl);
        setStyleImportant(labelEl, "display", "block");
        setStyleImportant(labelEl, "width", "");
        setStyleImportant(labelEl, "max-width", "");
        setStyleImportant(labelEl, "margin", "");
        setStyleImportant(labelEl, "white-space", "");
        setStyleImportant(labelEl, "overflow", "");
        setStyleImportant(labelEl, "text-overflow", "");
        setStyleImportant(labelEl, "transform", "none");
        setStyleImportant(labelEl, "transform-origin", "");
        setStyleImportant(labelEl, "font-size", "");
        setStyleImportant(labelEl, "line-height", "");
        setStyleImportant(labelEl, "letter-spacing", "");
        try {
          delete labelEl.dataset.mgpsPresetFitScale;
          delete labelEl.dataset.mgpsBaseFontSize;
          delete labelEl.dataset.mgpsBaseLineHeight;
        } catch (_) { }
        updatePresetFitDebug(labelEl, null);
      } catch (_) { }
    });
  }

  function isDebugAppearanceEnabled() {
    try {
      const params = new URLSearchParams(window.location.search || "");
      const value = String(params.get("mgps_debug_appearance") || "").trim().toLowerCase();
      return value === "1" || value === "true" || value === "yes" || value === "on";
    } catch (_) {
      return false;
    }
  }

  function isDebugPresetFitEnabled() {
    try {
      const params = new URLSearchParams(window.location.search || "");
      const value = String(params.get("mgps_debug_preset_fit") || "").trim().toLowerCase();
      return value === "1" || value === "true" || value === "yes" || value === "on";
    } catch (_) {
      return false;
    }
  }

  function updatePresetFitDebug(labelEl, values) {
    if (!labelEl || !labelEl.parentElement) return;
    try {
      let badge = labelEl.parentElement.querySelector(':scope > .mgps-debug-preset-fit');
      if (!isDebugPresetFitEnabled()) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement("div");
        badge.className = "mgps-debug-preset-fit";
        badge.style.cssText = [
          "margin-top:4px",
          "font:600 10px/1.2 monospace",
          "color:#0f172a",
          "background:rgba(255,255,0,.18)",
          "border:1px solid rgba(15,23,42,.18)",
          "border-radius:6px",
          "padding:4px 6px",
          "white-space:normal",
          "word-break:break-word"
        ].join(";");
        labelEl.parentElement.appendChild(badge);
      }
      const natural = Math.round(Number(values && values.naturalWidth || 0) || 0);
      const available = Math.round(Number(values && values.availableWidth || 0) || 0);
      const scale = Number(values && values.scale || 1).toFixed(3);
      const mobile = values && values.isMobile ? "mobile" : "desktop";
      const applied = values && values.applied ? "yes" : "no";
      badge.textContent = "preset-fit " + mobile + " natural=" + natural + " available=" + available + " scale=" + scale + " applied=" + applied;
    } catch (_) { }
  }

  function mountAppearanceDebugBadge(payload) {
    if (!isDebugAppearanceEnabled() || !document || !document.body) return;
    try {
      let host = document.getElementById("mgps-debug-appearance-host");
      if (!host) {
        host = document.createElement("div");
        host.id = "mgps-debug-appearance-host";
        host.style.position = "fixed";
        host.style.right = "12px";
        host.style.bottom = "12px";
        host.style.zIndex = "2147483647";
        host.style.display = "flex";
        host.style.flexDirection = "column";
        host.style.gap = "8px";
        host.style.maxWidth = "min(460px, calc(100vw - 24px))";
        host.style.pointerEvents = "none";
        document.body.appendChild(host);
      }
      const badgeId = "mgps-debug-appearance-badge-" + String(payload && payload.setName || "").replace(/[^a-z0-9_-]+/gi, "_");
      let badge = document.getElementById(badgeId);
      if (!badge) {
        badge = document.createElement("div");
        badge.id = badgeId;
        badge.style.padding = "10px 12px";
        badge.style.borderRadius = "10px";
        badge.style.background = "rgba(17,17,17,0.92)";
        badge.style.color = "#fff";
        badge.style.font = "12px/1.4 monospace";
        badge.style.whiteSpace = "pre-wrap";
        badge.style.boxShadow = "0 10px 30px rgba(0,0,0,0.35)";
        host.appendChild(badge);
      }
      const rootAppearance = payload && payload.rootAppearance || {};
      const rootSelectedAppearance = payload && payload.rootSelectedAppearance || {};
      badge.textContent = [
        "MGPS " + MGPS_DEBUG_BUILD,
        "set=" + String(payload && payload.setName || ""),
        "match=" + String(payload && payload.matchedSettingsKey || ""),
        "rootExplicit=" + String(!!(payload && payload.explicitRootAppearance)),
        "firstRowForceRoot=" + String(!!(payload && payload.firstRowForceRootAppearance)),
        "border=" + String(rootAppearance.border_color || ""),
        "bg=" + String(rootAppearance.background_color || ""),
        "shadow=" + String(rootAppearance.shadow_size ?? ""),
        "scope=" + String(rootAppearance.border_scope || ""),
        "selBorder=" + String(rootSelectedAppearance.border_color || "")
      ].join("\n");
    } catch (_) { }
  }

  function mergeSwatchAppearance(baseAppearance, overrideAppearance, fallbackScope = "image") {
    const base = baseAppearance && typeof baseAppearance === "object" ? baseAppearance : {};
    const over = overrideAppearance && typeof overrideAppearance === "object" ? overrideAppearance : {};
    const merged = Object.assign({}, base);
    [
      "border_color",
      "border_size",
      "shadow_size",
      "background_color",
      "background_image",
      "background_image_style",
      "product_image_padding",
      "border_scope",
      "border_radius_px",
      "image_radius_px",
      "gradient_color",
      "gradient_angle",
      "text_color",
      "text_behavior",
      "text_size_mobile",
      "text_size_desktop",
      "text_style"
    ].forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(over, key) && over[key] !== null && over[key] !== "") merged[key] = over[key];
    });
    return normalizeSwatchAppearance(merged, fallbackScope);
  }

  function getComputedCssVar(el, name) {
    try {
      if (!el || !name || typeof window === "undefined" || !window.getComputedStyle) return "";
      return String(window.getComputedStyle(el).getPropertyValue(name) || "").trim();
    } catch (_) {
      return "";
    }
  }

function parseRootSwatchAppearance(root) {
  function safeParse(json) {
    try { return JSON.parse(json || "{}"); }
    catch (_) { return {}; }
  }

  function getAttr(name) {
    return (root.getAttribute(name) || "").trim();
  }

  function pick(obj, key, attrName, fallback) {
    // Priority: JSON → attribute → fallback
    if (obj && obj[key] !== undefined && obj[key] !== null && obj[key] !== "") {
      return obj[key];
    }
    const attr = getAttr(attrName);
    if (attr !== "") return attr;
    return fallback;
  }

  const jsonAppearance = safeParse(getAttr("data-mgps-appearance"));
  const jsonSelected = safeParse(getAttr("data-mgps-selected-appearance"));

  const appearance = {
    border_color: pick(jsonAppearance, "border_color", "data-mgps-border-color", "#000000"),
    border_size: Number(pick(jsonAppearance, "border_size", "data-mgps-border-size", 2)),
    shadow_size: Number(pick(jsonAppearance, "shadow_size", "data-mgps-shadow-size", 0)),
    background_color: pick(jsonAppearance, "background_color", "data-mgps-background-color", "transparent"),
    border_scope: pick(jsonAppearance, "border_scope", "data-mgps-border-scope", "image"),
    text_color: pick(jsonAppearance, "text_color", "data-mgps-text-color", ""),
    text_behavior: pick(jsonAppearance, "text_behavior", "data-mgps-text-behavior", "wrap_text"),
    text_size_mobile: Number(pick(jsonAppearance, "text_size_mobile", "data-mgps-text-size-mobile", 0)),
    text_size_desktop: Number(pick(jsonAppearance, "text_size_desktop", "data-mgps-text-size-desktop", 0)),
    border_radius_px: Number(pick(jsonAppearance, "border_radius_px", "data-mgps-border-radius", 12)),
    image_radius_px: Number(pick(jsonAppearance, "image_radius_px", "data-mgps-image-radius", 12)),
    product_image_padding: Number(pick(jsonAppearance, "product_image_padding", "data-mgps-product-image-padding", 0)),
    gradient_color: pick(jsonAppearance, "gradient_color", "", ""),
    gradient_angle: Number(pick(jsonAppearance, "gradient_angle", "", 180)),
    text_style: pick(jsonAppearance, "text_style", "data-mgps-text-style", "")
  };

  const selected = {
    border_color: pick(jsonSelected, "border_color", "data-mgps-selected-border-color", appearance.border_color),
    border_size: Number(pick(jsonSelected, "border_size", "data-mgps-selected-border-size", appearance.border_size)),
    shadow_size: Number(pick(jsonSelected, "shadow_size", "data-mgps-selected-shadow-size", appearance.shadow_size)),
    background_color: pick(jsonSelected, "background_color", "data-mgps-selected-background-color", appearance.background_color),
    border_scope: pick(jsonSelected, "border_scope", "data-mgps-selected-border-scope", appearance.border_scope),
    text_color: pick(jsonSelected, "text_color", "data-mgps-selected-text-color", appearance.text_color),
    text_behavior: pick(jsonSelected, "text_behavior", "", appearance.text_behavior),
    text_size_mobile: Number(pick(jsonSelected, "text_size_mobile", "data-mgps-selected-text-size-mobile", appearance.text_size_mobile)),
    text_size_desktop: Number(pick(jsonSelected, "text_size_desktop", "data-mgps-selected-text-size-desktop", appearance.text_size_desktop)),
    border_radius_px: Number(pick(jsonSelected, "border_radius_px", "data-mgps-selected-border-radius", appearance.border_radius_px)),
    image_radius_px: Number(pick(jsonSelected, "image_radius_px", "data-mgps-selected-image-radius", appearance.image_radius_px)),
    product_image_padding: Number(pick(jsonSelected, "product_image_padding", "data-mgps-selected-product-image-padding", appearance.product_image_padding)),
    gradient_color: pick(jsonSelected, "gradient_color", "", appearance.gradient_color),
    gradient_angle: Number(pick(jsonSelected, "gradient_angle", "", appearance.gradient_angle)),
    text_style: pick(jsonSelected, "text_style", "data-mgps-selected-text-style", appearance.text_style)
  };

  const cornerRadiusPx = Number(getAttr("data-mgps-corner-radius")) || appearance.border_radius_px || 12;

  return {
    appearance,
    selectedAppearance: selected,
    cornerRadiusPx
  };
}

  function resolvedRowAppearance(rowSpec, isSelected) {
    const forceRoot = !!(rowSpec && rowSpec.__forceRootAppearance);
    const forceRootBorder = !!(rowSpec && rowSpec.__forceRootBorderAppearance);
    const rootTextBehavior = String(rowSpec && rowSpec.__rootTextBehaviorOverride || "").trim().toLowerCase();
    const rootNormal = normalizeSwatchAppearance((rowSpec && rowSpec.__rootAppearance) || null, "image");
    const rootSelected = normalizeSwatchAppearance((rowSpec && rowSpec.__rootSelectedAppearance) || null, rootNormal.border_scope || "image");
    rootSelected.border_scope = rootSelected.border_scope || rootNormal.border_scope || "image";
    if (rootTextBehavior) {
      rootNormal.text_behavior = rootTextBehavior;
      rootSelected.text_behavior = rootTextBehavior;
    }

    if (forceRoot) return isSelected ? rootSelected : rootNormal;

    const rowNormalSource = (rowSpec && (rowSpec.__appearance ?? rowSpec.appearance)) || null;
    const rowSelectedSource = (rowSpec && (rowSpec.__selectedAppearance ?? rowSpec.selected_appearance)) || null;
    const mergedNormal = mergeSwatchAppearance(rootNormal, rowNormalSource, rootNormal.border_scope || "image");
    const mergedSelected = mergeSwatchAppearance(rootSelected, rowSelectedSource, mergedNormal.border_scope || "image");
    if (rootTextBehavior) {
      mergedNormal.text_behavior = rootTextBehavior;
      mergedSelected.text_behavior = rootTextBehavior;
    }
    if (forceRootBorder) {
      [
        "border_color",
        "border_size",
        "border_scope",
        "shadow_size",
        "border_radius_px",
        "image_radius_px"
      ].forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(rootNormal, key) && rootNormal[key] !== null && rootNormal[key] !== "") {
          mergedNormal[key] = rootNormal[key];
        }
        if (Object.prototype.hasOwnProperty.call(rootSelected, key) && rootSelected[key] !== null && rootSelected[key] !== "") {
          mergedSelected[key] = rootSelected[key];
        }
      });
    }
    mergedSelected.border_scope = mergedSelected.border_scope || mergedNormal.border_scope || "image";
    return isSelected ? mergedSelected : mergedNormal;
  }

  function resolvedRowCornerRadiusPx(rowSpec, fallback = 12) {
    const rootValue = Number(rowSpec && rowSpec.__rootCornerRadiusPx);
    if (Number.isFinite(rootValue) && rootValue >= 0) return rootValue;
    const rowValue = Number(rowSpec && (rowSpec.__cornerRadiusPx ?? rowSpec.corner_radius_px));
    return Number.isFinite(rowValue) && rowValue >= 0 ? rowValue : fallback;
  }

  function resolvedAppearanceBorderRadiusPx(appearance, rowSpec, fallback = 12) {
    const direct = Number(appearance && (appearance.border_radius_px ?? appearance.borderRadiusPx));
    if (Number.isFinite(direct) && direct >= 0) return direct;
    return resolvedRowCornerRadiusPx(rowSpec, fallback);
  }

  function resolvedAppearanceImageRadiusPx(appearance, rowSpec, fallback = 12) {
    const direct = Number(appearance && (appearance.image_radius_px ?? appearance.imageRadiusPx));
    if (Number.isFinite(direct) && direct >= 0) return direct;
    return resolvedAppearanceBorderRadiusPx(appearance, rowSpec, fallback);
  }


  function topLightShadowValue(shadowSize) {
    const s = clampNumber(shadowSize, 0, 60, 0);
    if (!s) return "none";

    const y = Math.max(2, Math.round(s * 0.55));
    const blurVal = Math.max(4, Math.round(s * 1.35));

    return `0 ${y}px ${blurVal}px rgba(128,128,128,0.45)`;
  }

  function applyAppearanceBackground(el, appearance) {
    if (!el || !appearance) return;

    const bgColor = appearance.background_color || "transparent";
    const gradientEnd = appearance.gradient_color || "";
    const angle = appearance.gradient_angle || 180;
    const bgImage = safeSrc(appearance.background_image || "");

    /* 🔥 PRIORITY ORDER:
       1. Image
       2. Gradient
       3. Solid color
    */

    if (bgImage) {
      setStyleImportant(el, "background-image", `url("${bgImage.replace(/"/g, '%22')}")`);
      setStyleImportant(el, "background-color", bgColor);
      setStyleImportant(el, "background-repeat", "no-repeat");
      setStyleImportant(el, "background-position", "center center");

      switch (appearance.background_image_style) {
        case "stretch_to_fit":
          setStyleImportant(el, "background-size", "100% 100%");
          break;
        case "full_width":
          setStyleImportant(el, "background-size", "100% auto");
          break;
        case "full_height":
          setStyleImportant(el, "background-size", "auto 100%");
          break;
        default:
          setStyleImportant(el, "background-size", "cover");
          break;
      }

      return; // ⛔ STOP HERE so gradient doesn't overwrite image
    }

    if (gradientEnd) {
      setStyleImportant(
        el,
        "background-image",
        `linear-gradient(${angle}deg, ${bgColor}, ${gradientEnd})`
      );
      setStyleImportant(el, "background-color", "transparent");
      return;
    }

    /* fallback */
    setStyleImportant(el, "background-color", bgColor);
    setStyleImportant(el, "background-image", "none");
  }

  function applySwatchAppearance(card, block, slot, imgWrap, bottom, img, rowSpec, isSelected) {
    const appearance = resolvedRowAppearance(rowSpec, isSelected);
    const borderScope = normalizeBorderScope(appearance.border_scope, "image");
    const borderRadius = resolvedAppearanceBorderRadiusPx(appearance, rowSpec, 12);
    const imageRadius = resolvedAppearanceImageRadiusPx(appearance, rowSpec, 12);
    const borderSize = clampNumber(appearance.border_size, 0, 24, 2);
    const borderColor = collapseWhitespace(appearance.border_color || "#000000") || "#000000";
    const pad = clampNumber(appearance.product_image_padding, 0, 24, 0);
    const imgInner = imgWrap && imgWrap.querySelector ? imgWrap.querySelector(".mgps-img-inner") : null;

    try {
      [card, block, slot, imgWrap, imgInner, bottom].forEach((el) => {
        if (!el) return;
        setStyleImportant(el, "background", "transparent");
        setStyleImportant(el, "background-color", "transparent");
        setStyleImportant(el, "background-image", "none");
        setStyleImportant(el, "box-shadow", "none");
        setStyleImportant(el, "border", "0");
      });

      setStyleImportant(block, "display", "block");
      setStyleImportant(block, "width", "100%");
      setStyleImportant(block, "height", "100%");
      setStyleImportant(block, "padding", "0");
      setStyleImportant(block, "margin", "0");
      setStyleImportant(block, "box-sizing", "border-box");
      const shadowSize = clampNumber(appearance.shadow_size, 0, 60, 0);

      const shadowValue = topLightShadowValue(shadowSize);
      setStyleImportant(block, "overflow", borderScope === "image_text" ? "hidden" : "visible");
      setStyleImportant(block, "border-radius", borderScope === "image_text" ? (borderRadius + "px") : "0");
      if (borderScope === "image_text") {
        setStyleImportant(block, "border", borderSize + "px solid " + borderColor);
        setStyleImportant(block, "box-shadow", shadowValue);
        setStyleImportant(block, "filter", "none");
        applyAppearanceBackground(block, appearance);
      } else {
        setStyleImportant(block, "box-shadow", "none");
        setStyleImportant(block, "filter", "none");
      }

      setStyleImportant(slot, "display", "flex");
      setStyleImportant(slot, "width", "100%");
      setStyleImportant(slot, "min-width", "0");
      setStyleImportant(slot, "align-items", "stretch");
      setStyleImportant(slot, "justify-content", "center");
      setStyleImportant(slot, "box-sizing", "border-box");
      setStyleImportant(slot, "overflow", "hidden");
      setStyleImportant(slot, "border-radius", imageRadius + "px");
      if (borderScope === "image") {
        setStyleImportant(slot, "border", borderSize + "px solid " + borderColor);
        setStyleImportant(slot, "box-shadow", shadowValue);
        setStyleImportant(slot, "filter", "none");
        applyAppearanceBackground(slot, appearance);
      } else {
        setStyleImportant(slot, "box-shadow", "none");
        setStyleImportant(slot, "filter", "none");
      }

      setStyleImportant(imgWrap, "padding", pad + "px");
      try { imgWrap.style.setProperty("--mgps-image-pad", pad + "px"); } catch (_) { }
      setStyleImportant(imgWrap, "box-sizing", "border-box");
      setStyleImportant(imgWrap, "border-radius", imageRadius + "px");
      setStyleImportant(imgWrap, "overflow", "visible");
      setStyleImportant(imgWrap, "background", "transparent");
      if (imgInner) {
        setStyleImportant(imgInner, "position", "relative");
        setStyleImportant(imgInner, "width", "100%");
        setStyleImportant(imgInner, "height", "100%");
        setStyleImportant(imgInner, "min-width", "0");
        setStyleImportant(imgInner, "min-height", "0");
        setStyleImportant(imgInner, "overflow", "hidden");
        setStyleImportant(imgInner, "border-radius", imageRadius + "px");
        setStyleImportant(imgInner, "box-sizing", "border-box");
      }
      setStyleImportant(bottom, "display", "flex");
      setStyleImportant(bottom, "flex-direction", "column");
      setStyleImportant(bottom, "align-items", "center");
      setStyleImportant(bottom, "justify-content", "center");
      setStyleImportant(bottom, "text-align", "center");
      setStyleImportant(bottom, "background", "transparent");
      setStyleImportant(bottom, "margin-top", "4px");
      setStyleImportant(bottom, "padding", "8px 8px 10px");

      const textColor = collapseWhitespace(appearance.text_color || "");
      const defaultStyle = appearance.text_style || "normal";
      const selectedStyle = appearance.selected_text_style || "same";

      const textStyle = isSelected
        ? (selectedStyle === "same" ? defaultStyle : selectedStyle)
        : defaultStyle;
      const titleEl = bottom && bottom.querySelector ? bottom.querySelector(".mgps-title") : null;
      const priceEl = bottom && bottom.querySelector ? bottom.querySelector(".mgps-price") : null;
      [titleEl, priceEl].forEach((el) => {
        if (!el) return;

        /* RESET HARD (override theme CSS) */
        setStyleImportant(el, "display", "block");
        setStyleImportant(el, "font-style", "normal");
        setStyleImportant(el, "text-decoration", "none");
        setStyleImportant(el, "font-weight", "700");
        if (textColor) setStyleImportant(el, "color", textColor);

        /* APPLY STYLE */
        if (textStyle.includes("italic")) {
          setStyleImportant(el, "font-style", "italic");
        }

        if (textStyle.includes("underline")) {
          setStyleImportant(el, "text-decoration", "underline");
        }
      });
      const textBehavior = String(appearance.text_behavior || "wrap_text").trim().toLowerCase();
      if (titleEl) {
        if (textBehavior === "truncate_text" || textBehavior === "squeeze_text") {
          setStyleImportant(titleEl, "display", "block");
          setStyleImportant(titleEl, "white-space", "nowrap");
          setStyleImportant(titleEl, "overflow", textBehavior === "truncate_text" ? "hidden" : "visible");
          setStyleImportant(titleEl, "text-overflow", textBehavior === "truncate_text" ? "ellipsis" : "clip");
          setStyleImportant(titleEl, "-webkit-line-clamp", "unset");
          setStyleImportant(titleEl, "line-clamp", "unset");
          setStyleImportant(titleEl, "word-break", "normal");
          setStyleImportant(titleEl, "overflow-wrap", "normal");
          setStyleImportant(titleEl, "align-self", "center");
          setStyleImportant(titleEl, "text-align", "center");
          if (textBehavior === "squeeze_text") {
            setStyleImportant(titleEl, "width", "100%");
            setStyleImportant(titleEl, "max-width", "100%");
            setStyleImportant(titleEl, "margin", "0");
          }
        } else {
          setStyleImportant(titleEl, "display", "block");
          setStyleImportant(titleEl, "white-space", "normal");
          setStyleImportant(titleEl, "overflow", "visible");
          setStyleImportant(titleEl, "text-overflow", "clip");
          setStyleImportant(titleEl, "-webkit-line-clamp", "unset");
          setStyleImportant(titleEl, "line-clamp", "unset");
          setStyleImportant(titleEl, "word-break", "normal");
          setStyleImportant(titleEl, "overflow-wrap", "break-word");
          setStyleImportant(titleEl, "align-self", "center");
          setStyleImportant(titleEl, "text-align", "center");
        }
      }
      if (priceEl) {
        setStyleImportant(priceEl, "white-space", "nowrap");
        setStyleImportant(priceEl, "overflow", "hidden");
        setStyleImportant(priceEl, "text-overflow", textBehavior === "truncate_text" ? "ellipsis" : "clip");
      }
      updateTextFitDebugCard(card, textBehavior);

      if (img) {
        setStyleImportant(img, "border-radius", imageRadius + "px");
        if (card.dataset.scaleFill === "true") {
          setStyleImportant(img, "top", "0");
          setStyleImportant(img, "right", "0");
          setStyleImportant(img, "bottom", "0");
          setStyleImportant(img, "left", "0");
          setStyleImportant(img, "width", "100%");
          setStyleImportant(img, "height", "100%");
          setStyleImportant(img, "min-width", "100%");
          setStyleImportant(img, "min-height", "100%");
        }
      }
    } catch (_) { }
  }

  function parsePixelValue(raw, fallback = 0, max = 2400) {
    if (typeof raw === "number" && Number.isFinite(raw)) return Math.max(0, Math.min(max, Math.round(raw)));
    const s = String(raw == null ? "" : raw).trim();
    if (!s) return fallback;
    const match = s.match(/-?\d+(?:\.\d+)?/);
    if (!match) return fallback;
    const n = Number(match[0]);
    if (!Number.isFinite(n)) return fallback;
    return Math.max(0, Math.min(max, Math.round(n)));
  }

  function parseImgRatio(raw) {
    const s = String(raw || "1:1").trim();
    const m = s.match(/^(\d+(?:\.\d+)?)\s*[:/]\s*(\d+(?:\.\d+)?)$/);
    if (!m) return { w: 1, h: 1 };
    const w = Number(m[1]);
    const h = Number(m[2]);
    if (!(w > 0) || !(h > 0)) return { w: 1, h: 1 };
    return { w, h };
  }


  function currentRowHeight(rowEl) {
    if (!rowEl) return 0;
    const mobile = Math.max(0, Number(rowEl.dataset.rowHeightMobile || 0) || 0);
    const desktop = Math.max(0, Number(rowEl.dataset.rowHeightDesktop || rowEl.dataset.rowHeight || 0) || 0);
    return window.innerWidth <= 768 ? (mobile || desktop || 0) : (desktop || 0);
  }

  function currentPaddingBetweenRows(rowEl) {
    if (!rowEl) return 0;
    const mobile = Math.max(0, Number(rowEl.dataset.paddingBetweenRowsMobile || 0) || 0);
    const desktop = Math.max(0, Number(rowEl.dataset.paddingBetweenRowsDesktop || rowEl.dataset.paddingBetweenRows || 0) || 0);
    return window.innerWidth <= 768 ? (mobile || desktop || 0) : (desktop || 0);
  }

  function currentRowHeightFromSpec(rowSpec) {
    const mobile = Math.max(0, Number((rowSpec && rowSpec.row_height_mobile) || 0) || 0);
    const desktop = Math.max(0, Number((rowSpec && (rowSpec.row_height_desktop ?? rowSpec.row_height)) || 0) || 0);
    return window.innerWidth <= 768 ? (mobile || desktop || 0) : (desktop || 0);
  }

  function currentRowDisplayTypeFromSpec(rowSpec) {
    const desktop = String((rowSpec && (rowSpec.row_display_type_desktop ?? rowSpec.row_display_type)) || "scale_to_fit").trim().toLowerCase() || "scale_to_fit";
    const mobile = String((rowSpec && rowSpec.row_display_type_mobile) || desktop).trim().toLowerCase() || desktop;
    return window.innerWidth <= 768 ? mobile : desktop;
  }

  function currentRowDisplayType(rowEl) {
    if (!rowEl) return "scale_to_fit";
    const desktop = String(rowEl.dataset.rowDisplayTypeDesktop || rowEl.dataset.rowDisplayType || "scale_to_fit").trim().toLowerCase() || "scale_to_fit";
    const mobile = String(rowEl.dataset.rowDisplayTypeMobile || desktop).trim().toLowerCase() || desktop;
    return window.innerWidth <= 768 ? mobile : desktop;
  }

  function applyRowTextSizing(rowEl) {
    if (!rowEl) return;
    const rowHeight = currentRowHeight(rowEl);
    const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
    let minCardWidth = 0;
    cards.forEach((card) => {
      const w = Math.round(card.getBoundingClientRect().width || card.clientWidth || 0);
      if (w > 0 && (!minCardWidth || w < minCardWidth)) minCardWidth = w;
    });
    const sizeBasis = minCardWidth || rowHeight || 0;
    const rowSpec = rowEl.__rowSpec || {};
    const appearance = resolvedRowAppearance(rowSpec, false) || {};
    const customTitleSize = window.innerWidth <= 768
      ? Math.max(0, Number(appearance.text_size_mobile || 0) || 0)
      : Math.max(0, Number(appearance.text_size_desktop || 0) || 0);

    let titleSize = 11;
    let priceSize = 10;
    let lineHeight = 1.06;
    let paddingY = 3;
    let priceMarginTop = 1;

    if (customTitleSize > 0) {
      titleSize = customTitleSize;
      priceSize = Math.max(6, customTitleSize - 1);
      lineHeight = 1.1;
      paddingY = 3;
      priceMarginTop = 2;
    } else if (sizeBasis > 0) {
      titleSize = Math.max(7, Math.min(18, Math.round(sizeBasis * 0.12)));
      priceSize = Math.max(6, Math.min(14, Math.round(sizeBasis * 0.095)));
      if (sizeBasis <= 72) {
        lineHeight = 1.0;
        paddingY = 1;
        priceMarginTop = 0;
      } else if (sizeBasis <= 110) {
        lineHeight = 1.02;
        paddingY = 2;
        priceMarginTop = 1;
      } else {
        lineHeight = 1.06;
        paddingY = 3;
        priceMarginTop = 1;
      }
    }

    try {
      rowEl.style.setProperty("--mgps-title-size", titleSize + "px");
      rowEl.style.setProperty("--mgps-price-size", priceSize + "px");
      rowEl.style.setProperty("--mgps-text-line-height", String(lineHeight));
      rowEl.style.setProperty("--mgps-card-bottom-padding-y", paddingY + "px");
      rowEl.style.setProperty("--mgps-price-margin-top", priceMarginTop + "px");
      if (minCardWidth > 0) rowEl.style.setProperty("--mgps-card-width", minCardWidth + "px");
    } catch (_) { }

    cards.forEach((card) => {
      const titleEl = card.querySelector(".mgps-title");
      const priceEl = card.querySelector(".mgps-price");
      const isSelected = String(card.dataset.currentProduct || "") === "true";
      const appearanceForCard = resolvedRowAppearance(rowSpec, isSelected) || {};
      const squeezeText = String(appearanceForCard.text_behavior || "wrap_text").trim().toLowerCase() === "squeeze_text";
      if (titleEl) {
        setStyleImportant(titleEl, "font-size", titleSize + "px");
        setStyleImportant(titleEl, "line-height", String(lineHeight));
        setStyleImportant(titleEl, "font-weight", "700");
        try {
          titleEl.dataset.mgpsBaseFontSize = titleSize + "px";
          titleEl.dataset.mgpsBaseLineHeight = String(lineHeight);
        } catch (_) { }
        applySqueezedTextFit(titleEl, squeezeText);
      }
      if (priceEl) {
        setStyleImportant(priceEl, "font-size", priceSize + "px");
        setStyleImportant(priceEl, "line-height", String(lineHeight));
        setStyleImportant(priceEl, "font-weight", "700");
        setStyleImportant(priceEl, "margin-top", priceMarginTop + "px");
        try {
          priceEl.dataset.mgpsBaseFontSize = priceSize + "px";
          priceEl.dataset.mgpsBaseLineHeight = String(lineHeight);
        } catch (_) { }
        applySqueezedTextFit(priceEl, squeezeText);
      }
    });
  }

  function safeSrc(raw) {
    const s = String(raw || "").trim();
    if (!s) return "";
    if (/^\/\//.test(s)) return window.location.protocol + s;
    if (/^data:image\//i.test(s)) return s;
    try {
      const u = new URL(s, window.location.href);
      if (u.protocol === "http:" || u.protocol === "https:") {
        if (/cdn\.shopify\.com/i.test(u.hostname || "")) return cappedShopifyImageUrl(u.href, 2400, 400);
        return u.href;
      }
      return "";
    } catch (_) {
      return "";
    }
  }

  // Ensure any image `src` set on the page that points at Shopify CDN is capped reasonably without forcing it down to 400px
  ;(function enforceCappedShopifyImageSrc(){
    try {
      const desc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
      if (!desc || !desc.configurable) return;
      Object.defineProperty(HTMLImageElement.prototype, 'src', {
        get: function() { return desc.get.call(this); },
        set: function(val) {
          try {
            const s = String(val || '').trim();
            if (s && !/^data:/i.test(s) && /cdn\.shopify\.com/i.test(s)) {
              try {
                const newUrl = cappedShopifyImageUrl(s, 2400, 400);
                return desc.set.call(this, newUrl);
              } catch (_) {}
            }
          } catch (_) {}
          return desc.set.call(this, val);
        },
        configurable: true,
        enumerable: desc.enumerable
      });
    } catch (_) {}
  })();

  function safeLink(raw) {
    const s = String(raw || "").trim();
    if (!s) return "";

    if (/^shopify:\/\//i.test(s)) {
      const path = "/" + s.replace(/^shopify:\/\//i, "").replace(/^\/+/, "");
      try { return new URL(path, window.location.origin).href; } catch (_) { return ""; }
    }

    if (/^\//.test(s) && !/^\/\//.test(s)) {
      try { return new URL(s, window.location.origin).href; } catch (_) { return ""; }
    }

    try {
      const u = new URL(s, window.location.href);
      const allowed = ["http:", "https:", "mailto:", "tel:", "sms:"];
      return allowed.includes(u.protocol) ? u.href : "";
    } catch (_) {
      return "";
    }
  }

  function normalizeComparablePath(raw) {
    try {
      const u = new URL(String(raw || ""), window.location.href);
      let p = String(u.pathname || "").trim() || "/";
      p = p.replace(/\/+/g, "/");
      if (p.length > 1) p = p.replace(/\/+$/, "");
      return p.toLowerCase();
    } catch (_) {
      return "";
    }
  }

  function currentStorefrontProductPath() {
    return normalizeComparablePath(window.location.href);
  }

  function productJsonUrlFromMeta(meta) {
    const href = safeLink(meta?.product_url) || safeLink(meta?.cta?.href) || "";
    if (!href) return "";
    try {
      const url = new URL(href, window.location.href);
      url.search = "";
      url.hash = "";
      const path = String(url.pathname || "").replace(/\/+$/, "");
      if (!path) return "";
      return path + ".js";
    } catch (_) {
      return "";
    }
  }

  async function fetchProductJson(meta) {
    const url = productJsonUrlFromMeta(meta);
    if (!url) return null;
    R.__productJsonCache = R.__productJsonCache || Object.create(null);
    if (R.__productJsonCache[url]) return R.__productJsonCache[url];
    R.__productJsonCache[url] = fetch(url, { credentials: "same-origin" })
      .then((res) => res.ok ? res.json() : null)
      .catch(() => null);
    return R.__productJsonCache[url];
  }

  function formatMoneyCents(cents) {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return "";
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        const fmt = window.Shopify.money_format || "${{amount}}";
        return String(window.Shopify.formatMoney(amount, fmt) || "").trim();
      }
    } catch (_) { }
    try {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
      const lang = document.documentElement.lang || navigator.language || "en-US";
      return new Intl.NumberFormat(lang, { style: "currency", currency }).format(amount / 100);
    } catch (_) {
      return "$" + (amount / 100).toFixed(2);
    }
  }

  async function hydrateSwatchPrice(priceEl, meta) {
    if (!priceEl || !meta) return;
    const product = await fetchProductJson(meta);
    if (!product || typeof product !== "object") return;
    const cents = Number(product.price);
    if (!Number.isFinite(cents)) return;
    const text = formatMoneyCents(cents);
    if (!text) return;
    try {
      priceEl.textContent = text;
      priceEl.hidden = false;
    } catch (_) { }
  }

  function isCurrentProductTarget(meta) {
    const targetHref = safeLink(meta?.product_url) || safeLink(meta?.cta?.href) || "";
    const targetPath = normalizeComparablePath(targetHref);
    const currentPath = currentStorefrontProductPath();
    return !!targetPath && !!currentPath && targetPath === currentPath;
  }

  function productScalePct(meta, fallback = 100) {
    const raw = meta?.swatch_image_zoom
      ?? meta?.swatchImageZoom
      ?? meta?.product_image_scale
      ?? meta?.productImageScale
      ?? meta?.scale
      ?? meta?.__rowSwatchImageZoom
      ?? fallback;
    return clampImageZoomPct(raw, fallback);
  }

  function normalizeSwatchVerticalJustify(raw, fallback = "bottom") {
    const value = String(raw || "").trim().toLowerCase();
    if (value === "top" || value === "middle" || value === "bottom") return value;
    return fallback;
  }

  function productRandomZoomMaxPct(meta, fallback = 0) {
    const raw = meta?.random_zoom_max
      ?? meta?.randomZoomMax
      ?? meta?.__rowRandomZoomMax
      ?? meta?.random_swatch_image_zoom
      ?? meta?.randomSwatchImageZoom
      ?? fallback;
    return Math.round(clampNumber(raw, 0, 600, fallback));
  }

  function shouldRandomizeSwatchZoomArea(meta) {
    return isTrueLike(
      meta?.randomize_zoom_area
      ?? meta?.randomizeZoomArea
      ?? meta?.__rowRandomizeZoomArea
      ?? meta?.randomize_zoomed_swatch_area
      ?? meta?.randomizeZoomedSwatchArea
      ?? false
    );
  }

  function swatchZoomSeed(meta, salt = "") {
    const seedSource = String(
      meta?.product_id
      ?? meta?.productId
      ?? meta?.product_url
      ?? meta?.productUrl
      ?? meta?.title
      ?? ""
    ) + "|" + String(salt || "");
    let hash = 0;
    for (let i = 0; i < seedSource.length; i++) {
      hash = ((hash << 5) - hash + seedSource.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
  }

  function swatchZoomPresentation(meta, zoomPct) {
    if (!(Number(zoomPct) > 100) || !shouldRandomizeSwatchZoomArea(meta)) {
      return { objectPosition: "center center", flipX: 1, flipY: 1, shiftX: "0%", shiftY: "0%" };
    }
    const seedX = swatchZoomSeed(meta, "x");
    const seedY = swatchZoomSeed(meta, "y");
    const seedFlipX = swatchZoomSeed(meta, "flip-x");
    const seedFlipY = swatchZoomSeed(meta, "flip-y");
    const x = 8 + (seedX % 85);
    const y = 8 + (seedY % 85);
    const flipX = (seedFlipX % 2) ? -1 : 1;
    const flipY = (seedFlipY % 2) ? -1 : 1;
    const zoomFactor = Math.max(1, Number(zoomPct) / 100);
    const maxShift = Math.max(6, Math.min(28, Math.round((zoomFactor - 1) * 18)));
    const shiftX = ((x - 50) / 50) * maxShift;
    const shiftY = ((y - 50) / 50) * maxShift;
    return {
      objectPosition: x + "% " + y + "%",
      flipX,
      flipY,
      shiftX: shiftX.toFixed(2) + "%",
      shiftY: shiftY.toFixed(2) + "%"
    };
  }

  function resolvedSwatchZoomPct(meta, fallback = 100) {
    const minZoom = productScalePct(meta, fallback);
    const maxZoomRaw = productRandomZoomMaxPct(meta, 0);
    const maxZoom = maxZoomRaw > 0 ? Math.max(minZoom, maxZoomRaw) : minZoom;
    if (maxZoom <= minZoom) return minZoom;
    const seed = swatchZoomSeed(meta, "zoom");
    const steps = 6;
    const span = maxZoom - minZoom;
    const bucket = seed % steps;
    const zoom = minZoom + ((span * bucket) / steps);
    return Math.round(zoom);
  }

  function swatchImageRequestWidth(meta, card, slot, imgWrap) {
    if (shouldRandomizeSwatchZoomArea(meta)) return 2400;
    const displayWidth = currentSwatchRequestWidth(card, slot, imgWrap);
    const zoomPct = resolvedSwatchZoomPct(meta, 100);
    const requestedWidth = Math.max(displayWidth, Math.round(displayWidth * Math.max(1, zoomPct / 100)));
    return Math.min(2400, Math.max(400, requestedWidth));
  }

  function rawImageSrc(raw) {
    const s = String(raw || "").trim();
    if (!s) return "";
    if (/^\/\//.test(s)) return window.location.protocol + s;
    if (/^data:image\//i.test(s)) return s;
    try {
      const u = new URL(s, window.location.href);
      if (u.protocol === "http:" || u.protocol === "https:") return u.href;
      return "";
    } catch (_) {
      return "";
    }
  }

  function guessItemKind(it) {
    const tRaw = String(it?.type || it?.kind || it?.provider || "").trim().toLowerCase();
    if (tRaw === "product") return "product";
    if (tRaw === "image") return "image";
    if (tRaw === "swatch_popup_trigger") return "swatch_popup_trigger";
    if (tRaw === "video" || tRaw === "vimeo" || tRaw === "youtube" || tRaw === "file") return "image";
    if (collapseWhitespace(it?.product_url || it?.productUrl)) return "product";
    if (collapseWhitespace(it?.thumbnail || it?.image || it?.img || it?.url)) return "image";
    return null;
  }

  function normalizeItem(it, opts = {}) {
    if (!it || typeof it !== "object") return null;
    const source = (() => {
      const base = Object.assign({}, it);
      const matchKey = String(
        base.match_settings_preset_key ||
        base.matchPresetSettingsKey ||
        opts.matchSettingsPresetKey ||
        ""
      ).trim();
      if (!matchKey) return base;
      const matched = firstResolvedItemFromSet(matchKey);
      if (!matched || typeof matched !== "object") return base;
      const merged = Object.assign({}, matched, base);
      if (base.cta && typeof base.cta === "object") merged.cta = Object.assign({}, matched.cta || {}, base.cta);
      ["thumbnail", "image", "img"].forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(base, key)) delete merged[key];
      });
      if (!Object.prototype.hasOwnProperty.call(base, "product_image_id")) delete merged.product_image_id;
      return merged;
    })();
    const kind = guessItemKind(source);
    if (!kind) return null;
    const copy = Object.assign({}, source);
    copy.type = kind;
    if (kind === "swatch_popup_trigger") {
      copy.popup_swatches_per_row_mobile = Number(copy.popup_swatches_per_row_mobile || 0) || 0;
      copy.popup_swatches_per_row_desktop = Number(copy.popup_swatches_per_row_desktop || 0) || 0;
      return copy;
    }
    if (!copy.thumbnail && copy.product_image_url) copy.thumbnail = copy.product_image_url;
    if (!copy.thumbnail && copy.image) copy.thumbnail = copy.image;
    if (!copy.thumbnail && copy.img) copy.thumbnail = copy.img;
    return copy;
  }

  function normalizeItems(list, opts = {}) {
    const arr = Array.isArray(list) ? list : [];
    const out = [];
    for (const it of arr) {
      const normalized = normalizeItem(it, opts);
      if (normalized) out.push(normalized);
    }
    return out;
  }

  function rowItems(row) {
    return row?.swatches || row?.videos || row?.items || row?.cards || [];
  }

  function isRowLike(value) {
    return !!(value && typeof value === "object" && (Array.isArray(value.swatches) || Array.isArray(value.videos) || Array.isArray(value.items) || Array.isArray(value.cards)));
  }

  function cloneDeep(value) {
    try { return JSON.parse(JSON.stringify(value)); } catch (_) { return value; }
  }

  function getSetPayload(value) {
    if (value && typeof value === "object" && !Array.isArray(value) && Array.isArray(value.rows)) {
      return value;
    }
    return null;
  }

  function getSetMeta(value) {
    const payload = getSetPayload(value);
    if (!payload || !payload.meta || typeof payload.meta !== "object") return {};
    return Object.assign({}, payload.meta);
  }

  function firstResolvedRowFromSet(key) {
    const setKey = String(key || "").trim();
    if (!setKey) return null;
    try {
      const rows = resolveSet(setKey, new Set());
      return Array.isArray(rows) && rows.length ? rows[0] : null;
    } catch (_) {
      return null;
    }
  }

  function firstResolvedItemFromSet(key) {
    const row = firstResolvedRowFromSet(key);
    if (!row) return null;
      const items = normalizeItems(rowItems(row));
    return items.find((it) => {
      const t = String(it?.type || "").trim().toLowerCase();
      return t === "product" || t === "image";
    }) || null;
  }

  function resolveSetMeta(key, stack) {
    const setKey = String(key || "").trim();
    if (!setKey) return {};

    const seen = stack instanceof Set ? stack : new Set();
    if (seen.has(setKey)) return {};
    seen.add(setKey);

    const sourceValue = Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)
      ? R.__rawSpecs[setKey]
      : getSetStore()[setKey];

    let meta = cloneDeep(getSetMeta(sourceValue)) || {};
    const matchedSettingsKey = String(meta.match_settings_preset_key || meta.matchPresetSettingsKey || "").trim();
    if (matchedSettingsKey) {
      const matchedMeta = resolveSetMeta(matchedSettingsKey, seen);
      if (!isNonEmptyObject(meta.appearance) && isNonEmptyObject(matchedMeta.appearance)) meta.appearance = cloneDeep(matchedMeta.appearance);
      if (!isNonEmptyObject(meta.selected_appearance) && isNonEmptyObject(matchedMeta.selected_appearance)) meta.selected_appearance = cloneDeep(matchedMeta.selected_appearance);
      const matchedCorner = Number(matchedMeta.corner_radius_px);
      if (!Number.isFinite(Number(meta.corner_radius_px)) && Number.isFinite(matchedCorner) && matchedCorner >= 0) meta.corner_radius_px = matchedCorner;
    }
    const rawRows = coerceToRows(sourceValue);

    for (const rawRow of rawRows) {
      if (!rawRow || typeof rawRow !== "object") continue;
      const importKey = String(rawRow.__import_set || "").trim();
      if (importKey) {
        const importedMeta = resolveSetMeta(importKey, seen);
        if (!isNonEmptyObject(meta.appearance) && isNonEmptyObject(importedMeta.appearance)) meta.appearance = cloneDeep(importedMeta.appearance);
        if (!isNonEmptyObject(meta.selected_appearance) && isNonEmptyObject(importedMeta.selected_appearance)) meta.selected_appearance = cloneDeep(importedMeta.selected_appearance);
        const importedCorner = Number(importedMeta.corner_radius_px);
        if (!Number.isFinite(Number(meta.corner_radius_px)) && Number.isFinite(importedCorner) && importedCorner >= 0) meta.corner_radius_px = importedCorner;
      }

      if (!isNonEmptyObject(meta.appearance) && rawRow.appearance && typeof rawRow.appearance === "object") meta.appearance = cloneDeep(rawRow.appearance);
      if (!isNonEmptyObject(meta.selected_appearance) && rawRow.selected_appearance && typeof rawRow.selected_appearance === "object") meta.selected_appearance = cloneDeep(rawRow.selected_appearance);
      const rowCorner = Number(rawRow.corner_radius_px);
      if (!Number.isFinite(Number(meta.corner_radius_px)) && Number.isFinite(rowCorner) && rowCorner >= 0) meta.corner_radius_px = rowCorner;
    }

    seen.delete(setKey);
    return meta;
  }

  function coerceToRows(value) {
    if (!value) return [];

    const payload = getSetPayload(value);
    if (payload) value = payload.rows;

    if (Array.isArray(value)) {
      if (value.length && isRowLike(value[0])) {
        return value
          .map((row) => {
            if (!row || typeof row !== "object") return null;
            const copy = Object.assign({}, row);
            copy.videos = normalizeItems(rowItems(row));
            delete copy.items;
            delete copy.cards;
            return copy;
          })
          .filter(Boolean);
      }

      const items = normalizeItems(value);
      if (!items.length) return [];
      return [{
        heading: "",
        subheading: "",
        img_ratio: "1:1",
        row_height: 0,
        fit_row: false,
        margin_top: 0,
        margin_bottom: 0,
        swatch_row: true,
        row_justify: "center",
        heading_justify: "center",
        videos: items
      }];
    }

    if (typeof value === "object") {
      if (isRowLike(value)) {
        const copy = Object.assign({}, value);
        copy.videos = normalizeItems(rowItems(value));
        delete copy.items;
        delete copy.cards;
        return [copy];
      }
      const item = normalizeItem(value);
      if (!item) return [];
      return [{
        heading: "",
        subheading: "",
        img_ratio: "1:1",
        row_height: 0,
        fit_row: false,
        margin_top: 0,
        margin_bottom: 0,
        swatch_row: true,
        row_justify: "center",
        heading_justify: "center",
        videos: [item]
      }];
    }

    return [];
  }

  function normalizeRow(rowSpec, opts = {}) {
    const sourceRow = Object.assign({}, rowSpec || {});
    const matchedRowKey = String(
      sourceRow.match_settings_preset_key ||
      sourceRow.matchPresetSettingsKey ||
      opts.matchSettingsPresetKey ||
      ""
    ).trim();
    const row = (() => {
      if (!matchedRowKey) return sourceRow;
      const matchedRow = firstResolvedRowFromSet(matchedRowKey);
      if (!matchedRow || typeof matchedRow !== "object") return sourceRow;
      return Object.assign({}, matchedRow, sourceRow, {
        videos: rowItems(sourceRow),
        swatches: rowItems(sourceRow)
      });
    })();
    const rowDisplayType = String(
      row.row_display_type ||
      row.rowDisplayType ||
      (row.fit_row ? "scale_to_fit" : "scrollable")
    ).trim().toLowerCase() || "scrollable";
    const normalAppearance = row.appearance || row.swatch_appearance || row.__appearance || null;
    const selectedAppearance = row.selected_appearance || row.selectedAppearance || row.swatch_selected_appearance || row.__selectedAppearance || null;
    const hasExplicitNormalAppearance = appearanceHasVisualOverrides(normalAppearance);
    const hasExplicitSelectedAppearance = appearanceHasVisualOverrides(selectedAppearance);
    const normalizedAppearance = hasExplicitNormalAppearance ? normalizeSwatchAppearance(normalAppearance, "image") : null;
    const normalizedSelectedAppearance = hasExplicitSelectedAppearance
      ? normalizeSwatchAppearance(selectedAppearance, normalizedAppearance && normalizedAppearance.border_scope ? normalizedAppearance.border_scope : "image")
      : null;
    if (normalizedSelectedAppearance && normalizedAppearance && normalizedAppearance.border_scope) {
      normalizedSelectedAppearance.border_scope = normalizedSelectedAppearance.border_scope || normalizedAppearance.border_scope;
    }
    const normalizedItems = normalizeItems(rowItems(row), { matchSettingsPresetKey: matchedRowKey });
    const hasExplicitRowSwatchImageZoom =
      row.swatch_image_zoom != null
      || row.swatchImageZoom != null
      || row.product_image_scale != null
      || row.productImageScale != null
      || row.scale != null;
    const rowSwatchImageZoom = hasExplicitRowSwatchImageZoom
      ? (row.swatch_image_zoom ?? row.swatchImageZoom ?? row.product_image_scale ?? row.productImageScale ?? row.scale ?? 100)
      : null;
    const rowRandomZoomMax = row.random_zoom_max ?? row.randomZoomMax ?? 0;
    const rowSwatchVerticalJustify = normalizeSwatchVerticalJustify(row.swatch_vertical_justify ?? row.swatchVerticalJustify, "bottom");
    const rowRandomizeZoomArea = row.randomize_zoom_area ?? row.randomizeZoomArea ?? false;
    normalizedItems.forEach((item) => {
      if (rowSwatchImageZoom != null && !Object.prototype.hasOwnProperty.call(item, "__rowSwatchImageZoom")) item.__rowSwatchImageZoom = rowSwatchImageZoom;
      if (!Object.prototype.hasOwnProperty.call(item, "__rowSwatchVerticalJustify")) item.__rowSwatchVerticalJustify = rowSwatchVerticalJustify;
      if (!Object.prototype.hasOwnProperty.call(item, "__rowRandomZoomMax")) item.__rowRandomZoomMax = rowRandomZoomMax;
      if (!Object.prototype.hasOwnProperty.call(item, "__rowRandomizeZoomArea")) item.__rowRandomizeZoomArea = rowRandomizeZoomArea;
    });

    return {
      heading: typeof row.heading === "string" ? row.heading : "",
      subheading: typeof row.subheading === "string" ? row.subheading : "",
      heading_justify: String(row.heading_justify || "center").trim() || "center",
      img_ratio: String(row.img_ratio || "1:1").trim() || "1:1",
      row_height: Math.max(0, Number((row.row_height_desktop ?? row.row_height ?? 0)) || 0),
      row_height_mobile: Math.max(0, Number(row.row_height_mobile || 0) || 0),
      row_height_desktop: Math.max(0, Number((row.row_height_desktop ?? row.row_height ?? 0)) || 0),
      corner_radius_px: (() => { const v = Number(row.corner_radius_px); return Number.isFinite(v) && v >= 0 ? v : 12; })(),
      fit_row: rowDisplayType === "scale_to_fit",
      row_display_type_mobile: String(row.row_display_type_mobile || rowDisplayType).trim().toLowerCase() || rowDisplayType,
      row_display_type_desktop: String(row.row_display_type_desktop || rowDisplayType).trim().toLowerCase() || rowDisplayType,
      row_display_type: rowDisplayType,
      swatches_per_row_mobile: Math.max(0, Number(row.swatches_per_row_mobile || row.swatchesPerRowMobile || 0) || 0),
      swatches_per_row_desktop: Math.max(0, Number(row.swatches_per_row_desktop || row.swatchesPerRowDesktop || row.swatches_per_row || row.swatchesPerRow || 0) || 0),
      swatches_per_row: Math.max(0, Number(row.swatches_per_row_desktop || row.swatchesPerRowDesktop || row.swatches_per_row || row.swatchesPerRow || 0) || 0),
      padding_between_rows_mobile: Math.max(0, Number(row.padding_between_rows_mobile || row.paddingBetweenRowsMobile || 0) || 0),
      padding_between_rows_desktop: Math.max(0, Number(row.padding_between_rows_desktop || row.paddingBetweenRowsDesktop || row.padding_between_rows || row.paddingBetweenRows || 0) || 0),
      padding_between_rows: Math.max(0, Number(row.padding_between_rows_desktop || row.paddingBetweenRowsDesktop || row.padding_between_rows || row.paddingBetweenRows || 0) || 0),
      more_popup_text: typeof row.more_popup_text === "string" ? row.more_popup_text : "More",
      margin_top: Math.max(0, Number(row.margin_top || 0) || 0),
      margin_bottom: Math.max(0, Number(row.margin_bottom || 0) || 0),
      swatch_row: !!row.swatch_row,
      row_justify: String(row.row_justify || "center").trim() || "center",
      custom_html: typeof row.custom_html === "string" ? row.custom_html : "",
      custom_template_id: String(row.custom_template_id || "").trim(),
      custom_width_desktop_percent: clampNumber(row.custom_width_desktop_percent, 10, 100, 100),
      custom_width_mobile_percent: clampNumber(row.custom_width_mobile_percent, 10, 100, 100),
      custom_max_width_px: parsePixelValue(row.custom_max_width_px, 0),
      preset_button: !!row.preset_button,
      preset_button_text: typeof row.preset_button_text === "string" ? row.preset_button_text : (typeof row.heading === "string" ? row.heading : "Open Preset"),
      preset_modal_title: typeof row.preset_modal_title === "string" ? row.preset_modal_title : "",
      preset_hide_modal_header: !!row.preset_hide_modal_header,
      preset_button_set: String(row.preset_button_set || row.__preset_button_set || row.__import_set || "").trim(),
      preset_button_style: normalizePresetButtonStyle(row.preset_button_style || "dropdown_box", "dropdown_box"),
      preset_button_subtext: typeof row.preset_button_subtext === "string" ? row.preset_button_subtext : (typeof row.subheading === "string" ? row.subheading : ""),
      preset_button_image: safeSrc(row.preset_button_image || row.preset_button_image_url || row.button_image || row.button_image_url || ""),
      preset_button_image_alt: String(row.preset_button_image_alt || row.button_image_alt || "").trim(),
      preset_button_image_height_mobile: parsePixelValue(row.preset_button_image_height_mobile ?? row.button_image_height_mobile ?? row.preset_button_image_height ?? row.button_image_height, 0),
      preset_button_image_height_desktop: parsePixelValue(row.preset_button_image_height_desktop ?? row.button_image_height_desktop ?? row.preset_button_image_height ?? row.button_image_height, 0),
      preset_button_width_percent: normalizePresetButtonWidthPercent(row.preset_button_width_percent ?? row.button_width_percent, 0),
      preset_button_max_width_px: parsePixelValue(row.preset_button_max_width_px ?? row.button_max_width_px, 0),
        preset_button_heading_justify: String(row.preset_button_heading_justify || row.heading_justify || "center").trim().toLowerCase(),
        preset_button_border_color: collapseWhitespace(row.preset_button_border_color || ""),
        preset_button_border_size: clampNumber(row.preset_button_border_size, 0, 20, 1),
        preset_button_shadow_size: clampNumber(row.preset_button_shadow_size, 0, 60, 0),
        preset_button_border_radius_px: clampNumber(row.preset_button_border_radius_px, 0, 240, 4),
        preset_button_background_color: collapseWhitespace(row.preset_button_background_color || ""),
        preset_button_text_color: collapseWhitespace(row.preset_button_text_color || ""),
        preset_button_gradient_color: collapseWhitespace(row.preset_button_gradient_color || ""),
      preset_button_gradient_angle: clampNumber(row.preset_button_gradient_angle, 0, 360, 180),
      preset_button_background_image: safeSrc(row.preset_button_background_image || ""),
      preset_button_background_image_style: normalizeBackgroundImageStyle(row.preset_button_background_image_style, "center"),
      collapsed: !!row.collapsed,
      show_more_text: String(row.show_more_text || "Show more"),
      show_less_text: String(row.show_less_text || "Show less"),
      row_toggle_border_style: String(row.row_toggle_border_style || "solid"),
      hide_cta_buttons: !!row.hide_cta_buttons,
      end_behavior_override: String(row.end_behavior_override || ""),
      appearance: normalizedAppearance,
      selected_appearance: normalizedSelectedAppearance,
      __import_set: String(row.__import_set || "").trim(),
      __import_mode: String(row.__import_mode || "flatten").trim() || "flatten",
      __import_passthrough: !!row.__import_passthrough,
      __force_root_appearance: !!row.__force_root_appearance,
      videos: normalizedItems,
      swatches: normalizedItems
    };
  }

  function getSetStore() {
    const w = window;
    const candidate =
      (w.MG_SWATCH_SETS && typeof w.MG_SWATCH_SETS === "object")
        ? w.MG_SWATCH_SETS
        : (w.MEDIA_GALLERY_SETS && typeof w.MEDIA_GALLERY_SETS === "object")
          ? w.MEDIA_GALLERY_SETS
          : (w.VIMEO_VIDEO_SETS && typeof w.VIMEO_VIDEO_SETS === "object")
            ? w.VIMEO_VIDEO_SETS
            : null;

    if (candidate) {
      if (Object.getPrototypeOf(candidate) === null) {
        w.MG_SWATCH_SETS = candidate;
        return candidate;
      }
      const safe = Object.create(null);
      for (const key of Object.keys(candidate)) safe[key] = candidate[key];
      w.MG_SWATCH_SETS = safe;
      return safe;
    }

    const safe = Object.create(null);
    w.MG_SWATCH_SETS = safe;
    return safe;
  }

  function getSpecScripts(context) {
    const scope = context || document;
    const seen = new Set();
    const out = [];
    scope.querySelectorAll('script[data-mg-product-swatches-spec][type="application/json"], script[data-vimeo-control-spec][type="application/json"]').forEach((node) => {
      if (!node || seen.has(node)) return;
      seen.add(node);
      out.push(node);
    });
    return out;
  }

  function registerSpecs(context) {
    for (const script of getSpecScripts(context)) {
      const spec = safeJsonParse(script.textContent || "");
      const target = String(spec?.targetSet || "").trim();
      if (!target) continue;
      R.__rawSpecs[target] = { targetSet: target, rows: coerceToRows(spec.rows) };
    }
  }

  function mergeImportedRows(baseRow, importedRows) {
    const rows = cloneDeep(importedRows) || [];
    if (!rows.length) return rows;

    const first = rows[0];
    const last = rows[rows.length - 1];

    if (baseRow.heading || baseRow.subheading) {
      first.heading = baseRow.heading || first.heading || "";
      first.subheading = baseRow.subheading || first.subheading || "";
      first.heading_justify = baseRow.heading_justify || first.heading_justify || "center";
    }

    if (baseRow.margin_top) first.margin_top = (Number(first.margin_top || 0) || 0) + baseRow.margin_top;
    if (baseRow.margin_bottom) last.margin_bottom = (Number(last.margin_bottom || 0) || 0) + baseRow.margin_bottom;

    if (baseRow.custom_html || baseRow.custom_template_id) {
      const customRow = normalizeRow({
        heading: "",
        subheading: "",
        heading_justify: baseRow.heading_justify || "center",
        custom_html: baseRow.custom_html || "",
        custom_template_id: baseRow.custom_template_id || "",
        custom_width_desktop_percent: baseRow.custom_width_desktop_percent,
        custom_width_mobile_percent: baseRow.custom_width_mobile_percent,
        custom_max_width_px: baseRow.custom_max_width_px,
        img_ratio: "1:1",
        row_height: 0,
        fit_row: false,
        margin_top: baseRow.margin_top,
        margin_bottom: 0,
        videos: []
      });
      rows.unshift(customRow);
    }

    if (baseRow.appearance || baseRow.selected_appearance) {
      rows.forEach((row) => {
        if (!row || typeof row !== "object") return;
        if (baseRow.appearance) {
          row.appearance = mergeSwatchAppearance(row.appearance, baseRow.appearance, "image");
        }
        if (baseRow.selected_appearance) {
          const selectedScope = (
            (row.appearance && row.appearance.border_scope)
            || (baseRow.appearance && baseRow.appearance.border_scope)
            || "image"
          );
          row.selected_appearance = mergeSwatchAppearance(row.selected_appearance, baseRow.selected_appearance, selectedScope);
        }
        // Imported sets should fully honor wrapper appearance overrides when provided.
        row.__force_root_appearance = true;
      });
    }

    if (baseRow.videos && baseRow.videos.length) {
      last.videos = normalizeItems((last.videos || []).concat(baseRow.videos));
      last.swatches = last.videos;
    }

    return rows;
  }

  function resolveSet(key, stack, opts = {}) {
    const setKey = String(key || "").trim();
    if (!setKey) return [];

    const store = getSetStore();
    const inheritedMatchSettingsKey = String(opts && opts.matchSettingsPresetKey || "").trim();
    const seen = stack instanceof Set ? stack : new Set();
    if (seen.has(setKey)) return coerceToRows(store[setKey]);
    seen.add(setKey);

    const sourceEntry = Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)
      ? R.__rawSpecs[setKey]
      : store[setKey];
    const sourceValue = Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)
      ? R.__rawSpecs[setKey].rows
      : store[setKey];
    const sourceMeta = cloneDeep(getSetMeta(sourceEntry)) || {};
    const currentMatchSettingsKey = String(
      inheritedMatchSettingsKey ||
      sourceMeta.match_settings_preset_key ||
      sourceMeta.matchPresetSettingsKey ||
      ""
    ).trim();

    const rawRows = coerceToRows(sourceValue);
    const out = [];

    for (const rawRow of rawRows) {
      const row = normalizeRow(rawRow, { matchSettingsPresetKey: currentMatchSettingsKey });
      const importKey = String(row.__import_set || "").trim();
      const importMode = String(row.__import_mode || "flatten").trim().toLowerCase();
      const passthrough = !!row.__import_passthrough;

      if (!importKey) {
        out.push(row);
        continue;
      }

      const importedRows = resolveSet(importKey, seen, { matchSettingsPresetKey: currentMatchSettingsKey });
      if (!importedRows.length) {
        const missing = Object.assign({}, row);
        const msg = '<div class="mgps-missing-set">Preset set <code>' + escapeHtml(importKey) + '</code> was not found.</div>';
        missing.custom_html = (missing.custom_html || "") + msg;
        missing.preset_button_set = missing.preset_button_set || importKey;
        out.push(missing);
        continue;
      }

      if (row.preset_button) {
        const keep = Object.assign({}, row);
        keep.preset_button_set = keep.preset_button_set || importKey;
        keep.videos = [];
        out.push(keep);
        continue;
      }

      if (passthrough || importMode === "preserve") {
        const merged = mergeImportedRows(row, importedRows);
        out.push(...merged.map((mergedRow) => normalizeRow(mergedRow, { matchSettingsPresetKey: currentMatchSettingsKey })));
        continue;
      }

      const flatItems = [];
      for (const imported of importedRows) flatItems.push(...normalizeItems(rowItems(imported)));
      flatItems.push(...(row.videos || []));
      const flatRow = Object.assign({}, row, {
        __import_set: "",
        __import_mode: "flatten",
        __import_passthrough: false,
        videos: normalizeItems(flatItems)
      });
      out.push(flatRow);
    }

    seen.delete(setKey);
    try {
      if (Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)) {
        store[setKey] = cloneDeep(out);
      } else {
        const existingMeta = cloneDeep(getSetMeta(sourceValue)) || {};
        const hadPayload = !!getSetPayload(sourceValue);
        store[setKey] = hadPayload
          ? { meta: existingMeta, rows: cloneDeep(out) }
          : cloneDeep(out);
      }
    } catch (_) {
      store[setKey] = cloneDeep(out);
    }
    return out;
  }

  function buildFromDom(context) {
    registerSpecs(context || document);
    Object.keys(R.__rawSpecs).forEach((key) => {
      try { resolveSet(key, new Set()); } catch (_) { }
    });
    try { document.dispatchEvent(new Event("media_gallery_sets_ready")); } catch (_) { }
  }

  function getRoots(context) {
    const scope = context || document;
    const roots = [];
    if (scope.matches && scope.matches('[data-mg-product-swatches-root]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-mg-product-swatches-root]'));
    return roots;
  }

  function getExportBoxes(context) {
    const scope = context || document;
    const boxes = [];
    if (scope.matches && scope.matches('[data-mgps-export-box]')) boxes.push(scope);
    if (scope.querySelectorAll) boxes.push(...scope.querySelectorAll('[data-mgps-export-box]'));
    return boxes;
  }

  function buildRowHeading(rowSpec) {
    const headingHtml = String(rowSpec?.heading || "");
    const subheadingHtml = String(rowSpec?.subheading || "");
    if (!headingHtml.trim() && !subheadingHtml.trim()) return null;

    const justifyRaw = String(rowSpec?.heading_justify || "center").trim().toLowerCase();
    const justify = ["left", "center", "right"].includes(justifyRaw) ? justifyRaw : "center";

    const wrap = document.createElement("div");
    wrap.className = "mgps-row-heading-wrap";
    wrap.dataset.headingJustify = justify;

    if (headingHtml.trim()) {
      const heading = document.createElement("div");
      heading.className = "mgps-row-heading";
      heading.innerHTML = headingHtml;
      wrap.appendChild(heading);
    }

    if (subheadingHtml.trim()) {
      const subheading = document.createElement("div");
      subheading.className = "mgps-row-subheading";
      subheading.innerHTML = subheadingHtml;
      wrap.appendChild(subheading);
    }

    return wrap;
  }

  function activateClonedScripts(container) {
    if (!container || !container.querySelectorAll) return;
    const scripts = Array.from(container.querySelectorAll("script"));
    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script");
      for (const attr of Array.from(oldScript.attributes || [])) {
        newScript.setAttribute(attr.name, attr.value);
      }
      newScript.textContent = oldScript.textContent || "";
      oldScript.replaceWith(newScript);
    });
  }

  function renderCustomRow(rowSpec, rowWrap) {
    const customTemplateId = String(rowSpec?.custom_template_id || "").trim();
    const customRaw = String(rowSpec?.custom_html || "");
    if (!customTemplateId && !customRaw.trim()) return false;

    const customEl = document.createElement("div");
    customEl.className = "mgps-custom";
    customEl.setAttribute("data-custom-liquid", "true");

    let injected = false;
    if (customTemplateId) {
      const tpl = document.getElementById(customTemplateId);
      if (tpl) {
        const clone = tpl.cloneNode(true);
        try { clone.removeAttribute("id"); } catch (_) { }
        try { clone.removeAttribute("hidden"); } catch (_) { }
        try { clone.removeAttribute("aria-hidden"); } catch (_) { }
        while (clone.firstChild) customEl.appendChild(clone.firstChild);
        injected = true;
      }
    }

    if (!injected && customRaw.trim()) {
      customEl.innerHTML = customRaw;
    }

    let wrap = customEl.querySelector(":scope > .mg-custom-liquid-wrap");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "mg-custom-liquid-wrap";
      while (customEl.firstChild) wrap.appendChild(customEl.firstChild);
      customEl.appendChild(wrap);
    }

    wrap.style.setProperty("--mgps-custom-width-mobile", String(rowSpec?.custom_width_mobile_percent ?? 100) + "%");
    wrap.style.setProperty("--mgps-custom-width-desktop", String(rowSpec?.custom_width_desktop_percent ?? 100) + "%");
    wrap.style.setProperty("--mgps-custom-max-width", (Number(rowSpec?.custom_max_width_px || 0) > 0) ? (String(Number(rowSpec.custom_max_width_px)) + "px") : "none");

    rowWrap.appendChild(customEl);
    activateClonedScripts(customEl);
    return true;
  }

  function ensureModal() {
    if (R.__modal && R.__modal.node && R.__modal.node.isConnected) return R.__modal;

    const overlay = document.createElement("div");
    overlay.className = "mgps-modal";
    overlay.hidden = true;
    overlay.setAttribute("aria-hidden", "true");
    overlay.style.display = "none";
    overlay.style.pointerEvents = "none";

    const dialog = document.createElement("div");
    dialog.className = "mgps-modal__dialog";
    dialog.style.width = "min(1200px, calc(100vw - 48px))";
    dialog.style.maxWidth = "1200px";
    dialog.style.height = "auto";
    dialog.style.maxHeight = "90vh";
    dialog.style.borderRadius = "20px";
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    dialog.setAttribute("aria-labelledby", "mgps-modal-title");

    const header = document.createElement("div");
    header.className = "mgps-modal__header";

    const title = document.createElement("div");
    title.className = "mgps-modal__title";
    title.id = "mgps-modal-title";
    header.appendChild(title);

    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "mgps-modal__close";
    closeBtn.setAttribute("aria-label", "Close");
    closeBtn.textContent = "✕";
    header.appendChild(closeBtn);

    const body = document.createElement("div");
    body.className = "mgps-modal__body";

    dialog.appendChild(header);
    dialog.appendChild(body);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    // simple stack so nested modals restore the previous modal when closed
    R.__modalStack = R.__modalStack || [];

    function pushModalState() {
      try {
        if (!overlay || overlay.hidden || overlay.style.display === "none") return;
        const titleFrag = document.createDocumentFragment();
        while (title.firstChild) titleFrag.appendChild(title.firstChild);
        const bodyFrag = document.createDocumentFragment();
        while (body.firstChild) bodyFrag.appendChild(body.firstChild);
        const entry = {
          titleFrag,
          bodyFrag,
          swatchMeta: (R.__modal && R.__modal.__swatchPopupMeta) ? R.__modal.__swatchPopupMeta : null,
          dialogClass: dialog.className,
          headerStyle: header.getAttribute && header.getAttribute('style') || '',
          titleStyle: title.getAttribute && title.getAttribute('style') || '',
          closeBtnStyle: closeBtn.getAttribute && closeBtn.getAttribute('style') || ''
        };
        R.__modalStack.push(entry);
      } catch (_) { }
    }

    function popModalState() {
      try {
        if (!R.__modalStack || !R.__modalStack.length) return false;
        const entry = R.__modalStack.pop();
        try { while (title.firstChild) title.removeChild(title.firstChild); } catch (_) { }
        try { title.appendChild(entry.titleFrag); } catch (_) { }
        try { while (body.firstChild) body.removeChild(body.firstChild); } catch (_) { }
        try { body.appendChild(entry.bodyFrag); } catch (_) { }
        try { dialog.className = entry.dialogClass || dialog.className; } catch (_) { }
        try { if (header && header.setAttribute) header.setAttribute('style', entry.headerStyle || ''); } catch (_) { }
        try { if (title && title.setAttribute) title.setAttribute('style', entry.titleStyle || ''); } catch (_) { }
        try { if (closeBtn && closeBtn.setAttribute) closeBtn.setAttribute('style', entry.closeBtnStyle || ''); } catch (_) { }
        try { if (R.__modal) R.__modal.__swatchPopupMeta = entry.swatchMeta; } catch (_) { }
        return true;
      } catch (_) { return false; }
    }

    function closeModal() {
      try {
        // if there's a stacked state restore it instead of fully closing
        if (popModalState()) return;
      } catch (_) { }
      try { overlay.hidden = true; } catch (_) { }
      try { overlay.setAttribute("aria-hidden", "true"); } catch (_) { }
      try { overlay.style.display = "none"; } catch (_) { }
      try { overlay.style.pointerEvents = "none"; } catch (_) { }
      try { body.innerHTML = ""; } catch (_) { }
      try { title.textContent = ""; } catch (_) { }
      try {
        if (dialog) dialog.classList.remove("is-header-hidden");
        if (header) {
          header.style.display = "";
          header.style.padding = "";
          header.style.minHeight = "";
          header.style.borderBottom = "";
          header.style.height = "";
          header.style.overflow = "";
        }
        if (title) title.style.display = "";
        if (closeBtn) {
          closeBtn.style.position = "";
          closeBtn.style.top = "";
          closeBtn.style.right = "";
          closeBtn.style.left = "";
          closeBtn.style.bottom = "";
          closeBtn.style.display = "";
          closeBtn.style.alignItems = "";
          closeBtn.style.justifyContent = "";
          closeBtn.style.width = "";
          closeBtn.style.height = "";
          closeBtn.style.padding = "";
          closeBtn.style.margin = "";
          closeBtn.style.zIndex = "";
        }
      } catch (_) { }
      try { document.documentElement.classList.remove("mgps-modal-open"); } catch (_) { }
      try { document.body.classList.remove("mgps-modal-open"); } catch (_) { }
    }

    closeBtn.addEventListener("click", closeModal);
    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) closeModal();
    });

    if (!R.__escInstalled) {
      R.__escInstalled = true;
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && R.__modal && !R.__modal.node.hidden) {
          R.__modal.close();
        }
      });
      window.addEventListener("resize", () => {
        try {
          if (R.__modal && R.__modal.node && !R.__modal.node.hidden) {
            applyModalSizing(R.__modal);
            applyPresetButtonTextFit(R.__modal.node);
          }
          applyPresetButtonTextFit(document);
        } catch (_) { }
      });
    }

    R.__modal = { node: overlay, dialog, header, closeBtn, title, body, close: closeModal, push: pushModalState, pop: popModalState };
    return R.__modal;
  }

  function applyModalSizing(modal) {
    if (!modal || !modal.dialog || !modal.body) return;
    try {
      const viewportWidth = Math.max(window.innerWidth || 0, document.documentElement?.clientWidth || 0, 0);
      const viewportHeight = Math.max(window.innerHeight || 0, document.documentElement?.clientHeight || 0, 0);
      const isMobile = viewportWidth <= 768;
      const maxDialogHeight = viewportHeight > 0 ? Math.floor(viewportHeight * 0.9) : 0;
      const headerHeight = modal.header ? Math.ceil(modal.header.getBoundingClientRect().height || 0) : 0;

      modal.dialog.style.width = isMobile
        ? "96vw"
        : "min(1200px, calc(100vw - 48px))";
      modal.dialog.style.maxWidth = isMobile ? "96vw" : "1200px";
      modal.dialog.style.height = "auto";
      modal.dialog.style.minHeight = "0";
      modal.dialog.style.maxHeight = maxDialogHeight > 0 ? (String(maxDialogHeight) + "px") : "90vh";

      modal.body.style.boxSizing = "border-box";
      modal.body.style.overflowX = "hidden";
      modal.body.style.overflowY = "auto";
      modal.body.style.paddingBottom = isMobile ? "10%" : "5%";
      modal.body.style.maxHeight = maxDialogHeight > 0
        ? (String(Math.max(0, maxDialogHeight - headerHeight)) + "px")
        : "calc(90vh - 70px)";
    } catch (_) { }
  }

  function openPresetSet(setKey, label, opts = {}) {
    const key = String(setKey || "").trim();
    if (!key) return;

    try { buildFromDom(document); } catch (_) { }

    const rows = resolveSet(key, new Set());
    const modal = ensureModal();
    try { if (modal && modal.node && !modal.node.hidden && modal.node.style.display !== "none" && typeof modal.push === "function") modal.push(); } catch (_) { }
    const normalizedTitle = String(label == null ? key : label);
    const hideHeader = !!(opts && opts.hideHeader);
    const visibleTitle = hideHeader ? "" : plainTextFromMaybeHtml(normalizedTitle);

    modal.title.textContent = visibleTitle;

    try {
      if (modal.dialog) {
        modal.dialog.style.position = "relative";
        modal.dialog.classList.toggle("is-header-hidden", hideHeader);
      }
      if (modal.dialog) {
        modal.dialog.style.position = "relative";
      }
      if (modal.header) {
        if (hideHeader) {
          modal.header.style.display = "block";
          modal.header.style.padding = "0";
          modal.header.style.margin = "0";
          modal.header.style.minHeight = "0";
          modal.header.style.height = "0";
          modal.header.style.borderBottom = "0";
          modal.header.style.overflow = "visible";
        } else {
          modal.header.style.display = "";
          modal.header.style.padding = "";
          modal.header.style.margin = "";
          modal.header.style.minHeight = "";
          modal.header.style.height = "";
          modal.header.style.borderBottom = "";
          modal.header.style.overflow = "";
        }
      }
      if (modal.title) {
        modal.title.style.display = hideHeader ? "none" : "";
      }
      if (modal.closeBtn) {
        if (hideHeader) {
          modal.closeBtn.style.position = "absolute";
          modal.closeBtn.style.top = "12px";
          modal.closeBtn.style.right = "12px";
          modal.closeBtn.style.left = "auto";
          modal.closeBtn.style.bottom = "auto";
          modal.closeBtn.style.display = "inline-flex";
          modal.closeBtn.style.alignItems = "center";
          modal.closeBtn.style.justifyContent = "center";
          modal.closeBtn.style.width = "36px";
          modal.closeBtn.style.height = "36px";
          modal.closeBtn.style.padding = "0";
          modal.closeBtn.style.margin = "0";
          modal.closeBtn.style.zIndex = "999";
        } else {
          modal.closeBtn.style.position = "";
          modal.closeBtn.style.top = "";
          modal.closeBtn.style.right = "";
          modal.closeBtn.style.left = "";
          modal.closeBtn.style.bottom = "";
          modal.closeBtn.style.display = "";
          modal.closeBtn.style.alignItems = "";
          modal.closeBtn.style.justifyContent = "";
          modal.closeBtn.style.width = "";
          modal.closeBtn.style.height = "";
          modal.closeBtn.style.padding = "";
          modal.closeBtn.style.margin = "";
          modal.closeBtn.style.zIndex = "";
        }
      }
    } catch (_) { }

    modal.body.innerHTML = "";

    if (rows.length) {
      const rendered = renderRows(rows, { inModal: true, appearance: opts && opts.appearance, selectedAppearance: opts && opts.selectedAppearance, cornerRadiusPx: opts && opts.cornerRadiusPx, forceRootAppearance: false, matchSettingsPresetKey: opts && opts.matchSettingsPresetKey });
      modal.body.appendChild(rendered);
      try {
        requestAnimationFrame(() => {
          try {
            applyModalSizing(modal);
            rendered.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => { applyFitRow(rowEl); applyRowCornerRadius(rowEl); });
          } catch (_) { }
        });
      } catch (_) { }
    } else {
      const empty = document.createElement("div");
      empty.className = "mgps-modal__empty";
      empty.innerHTML = 'Preset set <code>' + escapeHtml(key) + '</code> was not found.';
      modal.body.appendChild(empty);
    }

    try { modal.node.hidden = false; } catch (_) { }
    try { modal.node.setAttribute("aria-hidden", "false"); } catch (_) { }
    try { modal.node.style.display = "flex"; } catch (_) { }
    try { modal.node.style.pointerEvents = "auto"; } catch (_) { }
    try { document.documentElement.classList.add("mgps-modal-open"); } catch (_) { }
    try { document.body.classList.add("mgps-modal-open"); } catch (_) { }
    try { requestAnimationFrame(() => applyModalSizing(modal)); } catch (_) { }
  }

  function makePresetButton(rowSpec) {
    const buttonStyle = normalizePresetButtonStyle(rowSpec?.preset_button_style || "dropdown_box", "dropdown_box");
    const headingJustifyRaw = String(rowSpec?.preset_button_heading_justify || "center").trim().toLowerCase();
    const headingJustify = ["left", "center", "right"].includes(headingJustifyRaw) ? headingJustifyRaw : "center";
    const button = document.createElement("button");
    button.type = "button";
    button.className = "mgps-preset-btn mgps-preset-btn--" + buttonStyle;
    button.setAttribute("data-mgps-preset-style", buttonStyle);
    button.style.position = "relative";
    button.style.zIndex = "5";
    button.style.pointerEvents = "auto";
    button.style.cursor = "pointer";
    if (buttonStyle === "button") {
      button.classList.add("button", "button--primary");
      button.style.maxWidth = "100%";
    } else if (buttonStyle === "button_primary") {
      button.classList.add("button", "button--primary");
      button.style.maxWidth = "100%";
    } else if (buttonStyle === "button_secondary") {
      button.classList.add("button", "button--secondary");
      button.style.maxWidth = "100%";
    }

    const widthPercent = normalizePresetButtonWidthPercent(rowSpec?.preset_button_width_percent, 0);
    const maxWidthPx = parsePixelValue(rowSpec?.preset_button_max_width_px, 0);
    const imageHeightMobilePx = parsePixelValue(rowSpec?.preset_button_image_height_mobile ?? rowSpec?.preset_button_image_height, 0);
    const imageHeightDesktopPx = parsePixelValue(rowSpec?.preset_button_image_height_desktop ?? rowSpec?.preset_button_image_height_mobile ?? rowSpec?.preset_button_image_height, 0);
    if (widthPercent > 0) button.style.setProperty("--mgps-preset-btn-width", widthPercent + "%");
    if (maxWidthPx > 0) button.style.setProperty("--mgps-preset-btn-max-width", maxWidthPx + "px");
    if (imageHeightMobilePx > 0) button.style.setProperty("--mgps-preset-btn-image-height-mobile", imageHeightMobilePx + "px");
    if (imageHeightDesktopPx > 0) button.style.setProperty("--mgps-preset-btn-image-height-desktop", imageHeightDesktopPx + "px");
    if (imageHeightDesktopPx > 0) button.style.setProperty("--mgps-preset-btn-image-height", imageHeightDesktopPx + "px");

    const rawButtonBorderColor = collapseWhitespace(rowSpec?.preset_button_border_color || "");
    const rawButtonBackgroundColor = collapseWhitespace(rowSpec?.preset_button_background_color || "");
    const rawButtonTextColor = collapseWhitespace(rowSpec?.preset_button_text_color || "");
    const buttonBorderColor = rawButtonBorderColor && rawButtonBorderColor !== "rgba(0,0,0,0)" && rawButtonBorderColor !== "rgba(0, 0, 0, 0)"
      ? rawButtonBorderColor
      : "rgba(var(--text-color), 0.15)";
    const buttonBorderSize = clampNumber(rowSpec?.preset_button_border_size, 0, 20, 1);
    const buttonShadowSize = clampNumber(rowSpec?.preset_button_shadow_size, 0, 60, 0);
    const buttonBorderRadiusPx = clampNumber(rowSpec?.preset_button_border_radius_px, 0, 240, 4);
    const buttonBackgroundColor = rawButtonBackgroundColor && rawButtonBackgroundColor !== "rgba(0,0,0,0)" && rawButtonBackgroundColor !== "rgba(0, 0, 0, 0)"
      ? rawButtonBackgroundColor
      : "rgb(var(--secondary-background))";
    const buttonTextColor = rawButtonTextColor && rawButtonTextColor !== "rgba(0,0,0,0)" && rawButtonTextColor !== "rgba(0, 0, 0, 0)"
      ? rawButtonTextColor
      : "rgb(var(--text-color))";
    const buttonGradientColor = collapseWhitespace(rowSpec?.preset_button_gradient_color || "");
    const buttonGradientAngle = clampNumber(rowSpec?.preset_button_gradient_angle, 0, 360, 180);
    const buttonBackgroundImage = safeSrc(rowSpec?.preset_button_background_image || "");
    const buttonBackgroundImageStyle = normalizeBackgroundImageStyle(rowSpec?.preset_button_background_image_style, "center");

    const buttonShadowValue = topLightShadowValue(buttonShadowSize);
    const buttonShadowYOffset = Math.max(2, Math.round(buttonShadowSize * 0.55));
    const buttonShadowBlur = Math.max(4, Math.round(buttonShadowSize * 1.35));

    button.style.borderColor = buttonBorderColor;
    button.style.borderWidth = buttonBorderSize + "px";
    button.style.borderStyle = buttonBorderSize > 0 ? "solid" : "none";
    button.style.borderRadius = buttonBorderRadiusPx + "px";
    button.style.setProperty("--mg-shadow-width", buttonShadowSize + "px");
    button.style.boxShadow = "none";
    button.style.filter = "none";
    button.style.backgroundColor = "transparent";
    button.style.color = buttonTextColor;
    button.style.overflow = "visible";

    const inner = document.createElement("span");
    inner.className = "mgps-preset-btn__inner";
    inner.style.borderColor = buttonBorderColor;
    inner.style.borderWidth = buttonBorderSize + "px";
    inner.style.borderStyle = buttonBorderSize > 0 ? "solid" : "none";
    inner.style.borderRadius = buttonBorderRadiusPx + "px";
    inner.style.backgroundColor = buttonBackgroundColor;
    inner.style.boxShadow = buttonShadowSize > 0 ? buttonShadowValue : "none";
    inner.style.overflow = "hidden";
    inner.style.color = buttonTextColor;

    const bgTarget = inner;
    if (buttonBackgroundImage) {
      bgTarget.style.backgroundImage = `url("${buttonBackgroundImage.replace(/"/g, '%22')}")`;
      bgTarget.style.backgroundRepeat = "no-repeat";
      switch (buttonBackgroundImageStyle) {
        case "stretch_to_fit":
          bgTarget.style.backgroundSize = "100% 100%";
          bgTarget.style.backgroundPosition = "center center";
          break;
        case "full_width":
          bgTarget.style.backgroundSize = "100% auto";
          bgTarget.style.backgroundPosition = "center center";
          break;
        case "full_height":
          bgTarget.style.backgroundSize = "auto 100%";
          bgTarget.style.backgroundPosition = "center center";
          break;
        default:
          bgTarget.style.backgroundSize = "cover";
          bgTarget.style.backgroundPosition = "center center";
          break;
      }
    } else if (buttonGradientColor) {
      bgTarget.style.backgroundImage = `linear-gradient(${buttonGradientAngle}deg, ${buttonBackgroundColor}, ${buttonGradientColor})`;
      bgTarget.style.backgroundRepeat = "no-repeat";
      bgTarget.style.backgroundSize = "100% 100%";
      bgTarget.style.backgroundPosition = "center center";
    } else {
      bgTarget.style.backgroundImage = "none";
      bgTarget.style.backgroundRepeat = "";
      bgTarget.style.backgroundSize = "";
      bgTarget.style.backgroundPosition = "";
    }

    const imageSrc = safeSrc(rowSpec?.preset_button_image || "");
    if (imageSrc) {
      const media = document.createElement("span");
      media.className = "mgps-preset-btn__media";
      const img = document.createElement("img");
      img.className = "mgps-preset-btn__image";
      img.loading = "lazy";
      img.decoding = "async";
      img.src = imageSrc;
      img.alt = String(rowSpec?.preset_button_image_alt || "");
      media.appendChild(img);
      inner.appendChild(media);
      button.classList.add("has-image");
    }

    const body = document.createElement("span");
    body.className = "mgps-preset-btn__body";
    body.style.alignItems = headingJustify === "left" ? "flex-start" : (headingJustify === "right" ? "flex-end" : "center");
    body.style.textAlign = headingJustify;

    const label = document.createElement("span");
    label.className = "mgps-preset-btn__label";
    label.innerHTML = String(rowSpec?.preset_button_text || rowSpec?.heading || "Open Preset");
    body.appendChild(label);

    const rawHintHtml = String(rowSpec?.preset_button_subtext ?? rowSpec?.subheading ?? "");
    const hintText = plainTextFromMaybeHtml(rawHintHtml);
    if (hintText) {
      const hint = document.createElement("span");
      hint.className = "mgps-preset-btn__hint";
      hint.innerHTML = rawHintHtml;
      body.appendChild(hint);
    } else {
      button.classList.add("mgps-preset-btn--single-line");
    }

    inner.appendChild(body);

    if (buttonStyle === "dropdown_box" || buttonStyle === "product_image_button") {
      const chevron = document.createElement("span");
      chevron.className = "mgps-preset-btn__chevron";
      chevron.setAttribute("aria-hidden", "true");
      chevron.textContent = "▾";
      inner.appendChild(chevron);
    }

    button.appendChild(inner);
    try {
      requestAnimationFrame(() => applyPresetButtonTextFit(button));
    } catch (_) { }

    const presetSet = String(rowSpec?.preset_button_set || rowSpec?.__import_set || "").trim();
    const buttonLabel = plainTextFromMaybeHtml(rowSpec?.preset_button_text || rowSpec?.heading || presetSet || "Open Preset");
    const modalTitle = Object.prototype.hasOwnProperty.call(rowSpec || {}, "preset_modal_title")
      ? String(rowSpec?.preset_modal_title ?? "")
      : String(rowSpec?.preset_button_text || rowSpec?.heading || presetSet || "Open Preset");
    const hideModalHeader = !!rowSpec?.preset_hide_modal_header;
    if (!presetSet) {
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
    } else {
      try {
        const preloadRows = resolveSet(presetSet, new Set());
        const preloadItems = normalizeItems(
          Array.isArray(preloadRows)
            ? preloadRows.flatMap((row) => rowItems(row))
            : [],
          { matchSettingsPresetKey: rowSpec && rowSpec.__rootMatchSettingsPresetKey }
        );
        queuePopupImagePreload(preloadItems);
      } catch (_) { }

      const openPreset = (event) => {
        try { event.preventDefault(); } catch (_) { }
        try { event.stopPropagation(); } catch (_) { }
        openPresetSet(presetSet, modalTitle, { hideHeader: hideModalHeader, appearance: rowSpec && (rowSpec.__rootAppearance || rowSpec.__appearance), selectedAppearance: rowSpec && (rowSpec.__rootSelectedAppearance || rowSpec.__selectedAppearance), cornerRadiusPx: rowSpec && (rowSpec.__rootCornerRadiusPx ?? rowSpec.__cornerRadiusPx) });
      };
      button.addEventListener("click", openPreset);
      button.addEventListener("touchend", openPreset);
    }

    return button;
  }

  function makeSwatchCard(meta, rowSpec, opts = {}) {
    const kind = String(meta?.type || "product").trim().toLowerCase() === "product" ? "product" : "image";
    const currentProduct = kind === "product" && isCurrentProductTarget(meta);
    const href = safeLink(meta?.cta?.href) || safeLink(meta?.product_url) || safeLink(meta?.url) || "";
    const ratio = parseImgRatio(rowSpec?.img_ratio || "1:1");
    const rowHeight = currentRowHeightFromSpec(rowSpec);

    const card = document.createElement("div");
    card.className = "mgps-thumb";
    card.style.position = "relative";
    card.style.zIndex = "1";
    const _mgpsScalePctCard = resolvedSwatchZoomPct(meta, 100);
    const _mgpsCornerRadius = resolvedRowCornerRadiusPx(rowSpec, (() => { const v = Number(meta?.corner_radius_px); return Number.isFinite(v) && v >= 0 ? v : 12; })());
    card.style.setProperty("--mgps-corner-radius", String(_mgpsCornerRadius) + "px");
    card.dataset.kind = kind;
    card.dataset.swatchMode = (kind === "product") ? "true" : "false";
    card.dataset.currentProduct = currentProduct ? "true" : "false";

    const block = document.createElement((href && !currentProduct) ? "a" : "div");
    block.className = "mgps-thumb-block";
    block.style.borderRadius = "0";
    if (block.tagName === "A") {
      block.href = href;
      block.target = "_self";
      block.setAttribute("aria-label", plainTextFromMaybeHtml(meta?.title || meta?.alt || "Open item") || "Open item");
      block.addEventListener("click", (event) => {
        try { event.preventDefault(); } catch (_) { }
        try { event.stopPropagation(); } catch (_) { }
        try {
          if (R.__modal && typeof R.__modal.close === "function") {
            R.__modal.close();
          }
        } catch (_) { }
        try { window.location.assign(href); } catch (_) {
          try { window.location.href = href; } catch (_) { }
        }
      });
    } else if (currentProduct) {
      block.setAttribute("aria-current", "page");
      block.setAttribute("aria-disabled", "true");
    }

    const slot = document.createElement("div");
    slot.className = "mgps-thumb-slot";
    slot.style.borderRadius = String(_mgpsCornerRadius) + "px";
    slot.style.setProperty("--mgps-corner-radius", String(_mgpsCornerRadius) + "px");

    const imgWrap = document.createElement("div");
    imgWrap.className = "mgps-img-wrap";
    imgWrap.style.borderRadius = String(_mgpsCornerRadius) + "px";
    imgWrap.style.setProperty("--mgps-corner-radius", String(_mgpsCornerRadius) + "px");
    imgWrap.style.setProperty("--mgps-row-aspect", ratio.w + " / " + ratio.h);
    if (rowHeight > 0) {
      imgWrap.classList.add("is-fixed-height");
      imgWrap.style.setProperty("--mgps-row-height", rowHeight + "px");
    }
    const imgInner = document.createElement("div");
    imgInner.className = "mgps-img-inner";
    imgInner.style.borderRadius = String(_mgpsCornerRadius) + "px";
    imgInner.style.setProperty("--mgps-corner-radius", String(_mgpsCornerRadius) + "px");

    const imageSrc = (() => {
      const baseSrc = shouldRandomizeSwatchZoomArea(meta)
        ? rawImageSrc(meta?.thumbnail || meta?.image || meta?.img || "")
        : safeSrc(meta?.thumbnail || meta?.image || meta?.img || "");
      if (!baseSrc) return "";
      try {
        return cappedShopifyImageUrl(baseSrc, 2400, swatchImageRequestWidth(meta, card, slot, imgWrap));
      } catch (_) {
        return baseSrc;
      }
    })();
    if (imageSrc) {
      const img = document.createElement("img");
      img.loading = opts && opts.inModal ? "eager" : "lazy";
      img.decoding = "async";
      if (opts && opts.inModal) {
        try { img.fetchPriority = "high"; } catch (_) { }
      }
      img.src = imageSrc;
      img.alt = String(meta?.alt || meta?.title || "").slice(0, 127);
      const _mgpsScalePct = resolvedSwatchZoomPct(meta, 100);
      const zoomPresentation = swatchZoomPresentation(meta, _mgpsScalePct);
      img.style.setProperty("--mgps-product-image-scale", String(_mgpsScalePct / 100));
      img.style.setProperty("--mgps-product-image-flip-x", String(zoomPresentation.flipX));
      img.style.setProperty("--mgps-product-image-flip-y", String(zoomPresentation.flipY));
      img.style.setProperty("--mgps-product-image-shift-x", String(zoomPresentation.shiftX || "0%"));
      img.style.setProperty("--mgps-product-image-shift-y", String(zoomPresentation.shiftY || "0%"));
      img.style.objectPosition = zoomPresentation.objectPosition;
        img.addEventListener("load", () => {
        const rowEl = card.closest(".mgps-thumb-row");
        if (rowEl) requestAnimationFrame(() => applyFitRow(rowEl));
      });
      imgInner.appendChild(img);
    } else {
      const placeholder = document.createElement("div");
      placeholder.className = "mgps-img-placeholder";
      placeholder.textContent = plainTextFromMaybeHtml(meta?.title || "Product");
      imgInner.appendChild(placeholder);
    }

    imgWrap.appendChild(imgInner);
    slot.appendChild(imgWrap);
    block.appendChild(slot);

    const bottom = document.createElement("div");
    bottom.className = "mgps-card-bottom";

    const title = document.createElement("div");
    title.className = "mgps-title";
    title.textContent = plainTextFromMaybeHtml(meta?.title || "");
    bottom.appendChild(title);

    const showPrice = kind === "product" && isTrueLike(meta?.show_price);
    const priceText = collapseWhitespace(meta?.price || "");
    if (showPrice && priceText) {
      const price = document.createElement("div");
      price.className = "mgps-price";
      price.textContent = priceText;
      bottom.appendChild(price);
      try { hydrateSwatchPrice(price, meta); } catch (_) { }
    } else if (showPrice) {
      const price = document.createElement("div");
      price.className = "mgps-price";
      price.hidden = true;
      bottom.appendChild(price);
      try { hydrateSwatchPrice(price, meta); } catch (_) { }
    }

    block.appendChild(bottom);
    applySwatchAppearance(
      card,
      block,
      slot,
      imgWrap,
      bottom,
      imgWrap.querySelector("img"),
      rowSpec,
      currentProduct
    );
    card.appendChild(block);
    return card;
  }

  function clearFitRow(rowEl) {
    if (!rowEl) return;
    const ratio = parseImgRatio(rowEl.dataset.imgRatio || "1:1");
    const aspect = Math.max(0.01, ratio.w / ratio.h);
    const rowHeight = currentRowHeight(rowEl);

    rowEl.querySelectorAll(":scope > .mgps-thumb").forEach((card) => {
      if (rowHeight > 0) {
        const width = Math.max(1, Math.floor(rowHeight * aspect));
        card.style.width = width + "px";
        card.style.maxWidth = "none";
        card.style.minWidth = "0px";
        card.style.flex = "0 0 " + width + "px";
      } else {
        card.style.removeProperty("width");
        card.style.removeProperty("max-width");
        card.style.removeProperty("min-width");
        card.style.flex = "0 0 auto";
      }
    });
  }

  function applyFitRow(rowEl) {
    if (!rowEl) return false;
    const rowDisplayType = currentRowDisplayType(rowEl);
    const forcedPerRowDesktop = Math.max(0, Number(rowEl.dataset.swatchesPerRowDesktop || rowEl.dataset.swatchesPerRow || 0) || 0);
    const forcedPerRowMobile = Math.max(0, Number(rowEl.dataset.swatchesPerRowMobile || 0) || 0);
    const isMobileBp = window.matchMedia ? window.matchMedia("(max-width: 767px)").matches : window.innerWidth <= 767;
    const forcedPerRow = isMobileBp ? forcedPerRowMobile : forcedPerRowDesktop;
    const viewport = rowEl.parentElement && rowEl.parentElement.classList.contains("mgps-row-viewport")
      ? rowEl.parentElement
      : rowEl;

    clearFitRow(rowEl);
    try {
      const next = viewport.nextElementSibling;
      if (next && next.classList && next.classList.contains("mgps-more-popup-wrap")) next.remove();
      viewport.style.maxHeight = "";
    } catch (_) { }

    try {
      if (rowDisplayType === "scrollable") {
        viewport.dataset.rowDisplayType = "scrollable";
        rowEl.dataset.rowDisplayType = "scrollable";
        rowEl.style.flexWrap = "nowrap";
        setStyleImportant(rowEl, "row-gap", "0px");
        rowEl.style.justifyContent = "flex-start";
        rowEl.style.width = "max-content";
        rowEl.style.maxWidth = "none";
        rowEl.style.minWidth = "100%";
        return false;
      }

      if (rowDisplayType === "wrap" || forcedPerRow > 0) {
        viewport.dataset.rowDisplayType = "wrap";
        rowEl.dataset.rowDisplayType = "wrap";
        rowEl.style.flexWrap = "wrap";
        setStyleImportant(rowEl, "row-gap", currentPaddingBetweenRows(rowEl) + "px");
        rowEl.style.justifyContent = "";
        rowEl.style.width = "100%";
        rowEl.style.minWidth = "0";
        if (forcedPerRow > 0) {
          const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
          const cs = getComputedStyle(rowEl);
          const gap = Number.parseFloat(cs.columnGap || cs.gap || "5") || 5;
          const count = Math.max(1, forcedPerRow);
          const widthExpr = "calc((100% - " + (gap * Math.max(0, count - 1)) + "px) / " + count + ")";
          cards.forEach((card) => {
            card.style.width = widthExpr;
            card.style.maxWidth = widthExpr;
            card.style.minWidth = "0";
            card.style.flex = "0 0 " + widthExpr;
          });
          applyRowTextSizing(rowEl);
        }
        const next = viewport.nextElementSibling;
        if (next && next.classList && next.classList.contains("mgps-more-popup-wrap")) next.remove();
        viewport.style.maxHeight = "";
        return false;
      }

      if (rowDisplayType === "wrap_more_popup") {
        viewport.dataset.rowDisplayType = "wrap_more_popup";
        rowEl.dataset.rowDisplayType = "wrap_more_popup";
        setStyleImportant(rowEl, "row-gap", currentPaddingBetweenRows(rowEl) + "px");
        applyWrapMorePopup(rowEl, rowEl.__rowSpec || {});
        return false;
      }

      const next = viewport.nextElementSibling;
      if (next && next.classList && next.classList.contains("mgps-more-popup-wrap")) next.remove();
      viewport.style.maxHeight = "";
      viewport.dataset.rowDisplayType = "scale_to_fit";
      rowEl.dataset.rowDisplayType = "scale_to_fit";
      rowEl.style.flexWrap = "nowrap";
      setStyleImportant(rowEl, "row-gap", "0px");
      rowEl.style.justifyContent = "";
      rowEl.style.width = "100%";
      rowEl.style.minWidth = "0";
    } catch (_) { }

    const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
    if (!cards.length) return false;

    const cs = getComputedStyle(rowEl);
    const gap = Number.parseFloat(cs.columnGap || cs.gap || "5") || 5;
    const innerWidth = Math.max(0, Math.floor(viewport.clientWidth));
    if (!(innerWidth > 0)) return false;

    const ratio = parseImgRatio(rowEl.dataset.imgRatio || "1:1");
    const aspect = Math.max(0.01, ratio.w / ratio.h);
    const rowHeight = currentRowHeight(rowEl);

    let width = Math.max(1, Math.floor((innerWidth - (gap * Math.max(0, cards.length - 1))) / cards.length));
    if (rowHeight > 0) width = Math.min(width, Math.max(1, Math.floor(rowHeight * aspect)));

    cards.forEach((card) => {
      card.style.width = width + "px";
      card.style.maxWidth = width + "px";
      card.style.minWidth = "0px";
      card.style.flex = "0 0 " + width + "px";
    });
    applyRowTextSizing(rowEl);
    return true;
  }


  function openRowPopup(rowSpec) {
    const modal = ensureModal();
    try { if (modal && modal.node && !modal.node.hidden && modal.node.style.display !== "none" && typeof modal.push === "function") modal.push(); } catch (_) { }
    const headingText = plainTextFromMaybeHtml(rowSpec?.heading || "");
    modal.title.textContent = headingText;
    try {
      if (modal.dialog) {
        modal.dialog.style.position = "relative";
        modal.dialog.classList.remove("is-header-hidden");
      }
      if (modal.header) {
        modal.header.style.display = "";
        modal.header.style.padding = "";
        modal.header.style.margin = "";
        modal.header.style.minHeight = "";
        modal.header.style.height = "";
        modal.header.style.borderBottom = "";
        modal.header.style.overflow = "";
      }
      if (modal.title) modal.title.style.display = "";
      if (modal.closeBtn) {
        modal.closeBtn.style.position = "";
        modal.closeBtn.style.top = "";
        modal.closeBtn.style.right = "";
        modal.closeBtn.style.left = "";
        modal.closeBtn.style.bottom = "";
        modal.closeBtn.style.display = "";
        modal.closeBtn.style.alignItems = "";
        modal.closeBtn.style.justifyContent = "";
        modal.closeBtn.style.width = "";
        modal.closeBtn.style.height = "";
        modal.closeBtn.style.padding = "";
        modal.closeBtn.style.margin = "";
        modal.closeBtn.style.zIndex = "";
      }
    } catch (_) { }
    modal.body.innerHTML = "";

    const popupRow = Object.assign({}, rowSpec || {});
    popupRow.heading = "";
    popupRow.subheading = "";
    popupRow.row_display_type = "wrap";
    popupRow.row_display_type_mobile = "wrap";
    popupRow.row_display_type_desktop = "wrap";
    popupRow.fit_row = false;

    popupRow.__appearance = rowSpec && rowSpec.__appearance;
    popupRow.__selectedAppearance = rowSpec && rowSpec.__selectedAppearance;
    modal.body.appendChild(renderRows([popupRow], { inModal: true, appearance: popupRow.__appearance, selectedAppearance: popupRow.__selectedAppearance, matchSettingsPresetKey: rowSpec && rowSpec.__rootMatchSettingsPresetKey }));
    try { modal.node.hidden = false; } catch (_) { }
    try { modal.node.setAttribute("aria-hidden", "false"); } catch (_) { }
    try { modal.node.style.display = "flex"; } catch (_) { }
    try { modal.node.style.pointerEvents = "auto"; } catch (_) { }
    try { document.documentElement.classList.add("mgps-modal-open"); } catch (_) { }
    try { document.body.classList.add("mgps-modal-open"); } catch (_) { }
  }

  function applyWrapMorePopup(rowEl, rowSpec) {
    if (!rowEl) return;
    const viewport = rowEl.parentElement && rowEl.parentElement.classList.contains("mgps-row-viewport")
      ? rowEl.parentElement
      : null;
    if (!viewport) return;

    let wrap = viewport.nextElementSibling;
    if (!(wrap && wrap.classList && wrap.classList.contains("mgps-more-popup-wrap"))) {
      wrap = null;
    }

    try {
      rowEl.style.flexWrap = "wrap";
      rowEl.style.justifyContent = "";
      rowEl.style.width = "100%";
      rowEl.style.minWidth = "0";
    } catch (_) { }

    const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
    if (!cards.length) return;

    const firstTop = cards[0].offsetTop;
    let firstRowBottom = firstTop;
    for (const card of cards) {
      if (card.offsetTop === firstTop) {
        firstRowBottom = Math.max(firstRowBottom, card.offsetTop + card.offsetHeight);
      }
    }
    const collapsedHeight = Math.max(1, firstRowBottom);
    const needsMore = cards.some((card) => card.offsetTop > firstTop);

    if (!needsMore) {
      try { viewport.style.maxHeight = ""; } catch (_) { }
      if (wrap) wrap.remove();
      return;
    }

    try { viewport.style.maxHeight = collapsedHeight + "px"; } catch (_) { }

    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "mgps-more-popup-wrap";
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "mgps-more-popup-btn button button--secondary";
      btn.textContent = String(rowSpec?.more_popup_text || rowEl.dataset.morePopupText || "More");
      btn.addEventListener("click", (event) => {
        try { event.preventDefault(); } catch (_) { }
        try { event.stopPropagation(); } catch (_) { }
        openRowPopup(rowSpec);
      });
      wrap.appendChild(btn);
      viewport.insertAdjacentElement("afterend", wrap);
    } else {
      const btn = wrap.querySelector(".mgps-more-popup-btn");
      if (btn) btn.textContent = String(rowSpec?.more_popup_text || rowEl.dataset.morePopupText || "More");
    }
  }


  function makeSwatchPopupButton(meta, rowSpec, popupItems) {
    const buttonStyle = normalizePresetButtonStyle(meta?.button_style || "dropdown_box", "dropdown_box");
    const widthPercent = normalizePresetButtonWidthPercent(meta?.button_width_percent, 100);
    const buttonJustify = String(meta?.button_justify || "left").trim().toLowerCase() || "left";
    const isThemeButton = buttonStyle === "button_primary" || buttonStyle === "button_secondary";

    const button = document.createElement("button");
    button.type = "button";
    const buttonHeightPx = Math.max(0, Number(meta?.button_height_px || 0) || 0);

    button.setAttribute("data-mgps-preset-style", buttonStyle);
    button.setAttribute("data-button-justify", buttonJustify);
    button.style.setProperty("--mgps-swatch-popup-btn-width", widthPercent + "%");
    if (buttonHeightPx > 0) {
      button.style.setProperty("--mgps-swatch-popup-btn-height", buttonHeightPx + "px");
      button.style.minHeight = buttonHeightPx + "px";
    }
    button.style.width = "min(100%, " + widthPercent + "%)";
    button.style.maxWidth = "100%";
    button.style.minWidth = "fit-content";
    button.style.flex = "0 0 auto";
    button.style.margin = "0";

    if (isThemeButton) {
      button.className = "mgps-swatch-popup-theme-btn button";
      if (buttonStyle === "button_primary") button.classList.add("button--primary");
      if (buttonStyle === "button_secondary") button.classList.add("button--secondary");
      button.style.display = "inline-flex";
      button.style.alignItems = "center";
      button.style.justifyContent = "center";
      button.style.whiteSpace = "normal";

      const label = document.createElement("span");
      label.className = "mgps-swatch-popup-theme-btn__label";
      label.innerHTML = String(meta?.button_text || "<p>View All</p>");
      button.appendChild(label);
    } else {
      button.className = "mgps-preset-btn mgps-preset-btn--" + buttonStyle;

      const inner = document.createElement("span");
      inner.className = "mgps-preset-btn__inner";

      const imageSrc = safeSrc(meta?.button_image || "");
      if (imageSrc) {
        const media = document.createElement("span");
        media.className = "mgps-preset-btn__media";
        const img = document.createElement("img");
        img.className = "mgps-preset-btn__image";
        img.loading = "lazy";
        img.decoding = "async";
        img.src = imageSrc;
        img.alt = String(meta?.button_image_alt || plainTextFromMaybeHtml(meta?.button_text || "View All"));
        media.appendChild(img);
        inner.appendChild(media);
        button.classList.add("has-image");
      }

      const body = document.createElement("span");
      body.className = "mgps-preset-btn__body";
      const label = document.createElement("span");
      label.className = "mgps-preset-btn__label";
      label.innerHTML = String(meta?.button_text || "<p>View All</p>");
      body.appendChild(label);
      button.classList.add("mgps-preset-btn--single-line");
      inner.appendChild(body);

      if (buttonStyle === "dropdown_box") {
        const chevron = document.createElement("span");
        chevron.className = "mgps-preset-btn__chevron";
        chevron.setAttribute("aria-hidden", "true");
        chevron.textContent = "▾";
        inner.appendChild(chevron);
      }

      button.appendChild(inner);
    }

    button.addEventListener("click", (event) => {
      try { event.preventDefault(); } catch (_) { }
      try { event.stopPropagation(); } catch (_) { }
      openSwatchPopup(rowSpec, popupItems, meta);
    });

    return button;
  }


  function applySwatchPopupGrid(renderedRoot, meta = {}) {
    if (!renderedRoot || !renderedRoot.querySelectorAll) return;

    const mobile = Math.max(0, Number(meta?.popup_swatches_per_row_mobile || 0) || 0);
    const desktop = Math.max(0, Number(meta?.popup_swatches_per_row_desktop || 0) || 0);
    const perRow = window.innerWidth <= 768 ? (mobile || desktop || 0) : (desktop || 0);

    if (!(perRow > 0)) return;

    renderedRoot.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
      const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb"));
      if (!cards.length) return;

      const viewport = rowEl.parentElement && rowEl.parentElement.classList.contains("mgps-row-viewport")
        ? rowEl.parentElement
        : null;

      const measureEl = viewport || rowEl;
      const cs = getComputedStyle(rowEl);
      const gap = Number.parseFloat(cs.columnGap || cs.gap || "5") || 5;
      const availableWidth = Math.max(0, Math.floor(measureEl.clientWidth || rowEl.clientWidth));
      if (!(availableWidth > 0)) return;

      const cardWidth = Math.max(1, Math.floor((availableWidth - (gap * Math.max(0, perRow - 1))) / perRow));

      if (viewport) {
        viewport.style.width = "100%";
        viewport.style.maxWidth = "100%";
        viewport.style.minWidth = "0";
        viewport.style.overflowX = "visible";
        viewport.style.overflowY = "visible";
      }

      rowEl.dataset.rowDisplayType = "wrap";
      rowEl.style.display = "flex";
      rowEl.style.flexWrap = "wrap";
      rowEl.style.justifyContent = "flex-start";
      rowEl.style.alignItems = "stretch";
      rowEl.style.width = "100%";
      rowEl.style.maxWidth = "100%";
      rowEl.style.minWidth = "0";
      rowEl.style.overflow = "visible";

      cards.forEach((card) => {
        card.style.width = cardWidth + "px";
        card.style.maxWidth = cardWidth + "px";
        card.style.minWidth = "0px";
        card.style.flex = "0 0 " + cardWidth + "px";
      });
    });
  }

  function openSwatchPopup(rowSpec, popupItems, meta = {}) {
    const modal = ensureModal();
    try { if (modal && modal.node && !modal.node.hidden && modal.node.style.display !== "none" && typeof modal.push === "function") modal.push(); } catch (_) { }
    const titleText = plainTextFromMaybeHtml((meta && meta.popup_title) || rowSpec?.heading || meta?.button_text || "View All");
    modal.title.textContent = titleText;

    try {
      if (modal.dialog) modal.dialog.classList.remove("is-header-hidden");
      if (modal.header) {
        modal.header.style.display = "";
        modal.header.style.padding = "";
        modal.header.style.margin = "";
        modal.header.style.minHeight = "";
        modal.header.style.height = "";
        modal.header.style.borderBottom = "";
        modal.header.style.overflow = "";
      }
      if (modal.title) modal.title.style.display = "";
      if (modal.closeBtn) {
        modal.closeBtn.style.position = "";
        modal.closeBtn.style.top = "";
        modal.closeBtn.style.right = "";
        modal.closeBtn.style.left = "";
        modal.closeBtn.style.bottom = "";
        modal.closeBtn.style.display = "";
        modal.closeBtn.style.alignItems = "";
        modal.closeBtn.style.justifyContent = "";
        modal.closeBtn.style.width = "";
        modal.closeBtn.style.height = "";
        modal.closeBtn.style.padding = "";
        modal.closeBtn.style.margin = "";
        modal.closeBtn.style.zIndex = "";
      }
    } catch (_) { }

    modal.body.innerHTML = "";
    modal.__swatchPopupMeta = meta;

    const popupRow = normalizeRow(Object.assign({}, rowSpec || {}, {
      heading: "",
      subheading: "",
      fit_row: false,
      row_display_type_mobile: "wrap",
      row_display_type_desktop: "wrap",
      row_display_type: "wrap",
      videos: popupItems
    }), { matchSettingsPresetKey: rowSpec && rowSpec.__rootMatchSettingsPresetKey });
    popupRow.__appearance = rowSpec && (rowSpec.__rootAppearance || rowSpec.__appearance);
    popupRow.__selectedAppearance = rowSpec && (rowSpec.__rootSelectedAppearance || rowSpec.__selectedAppearance);
    popupRow.__cornerRadiusPx = rowSpec && (rowSpec.__rootCornerRadiusPx ?? rowSpec.__cornerRadiusPx);

    const rendered = renderRows([popupRow], { inModal: true, appearance: popupRow.__appearance, selectedAppearance: popupRow.__selectedAppearance, cornerRadiusPx: popupRow.__cornerRadiusPx, forceRootAppearance: false, matchSettingsPresetKey: rowSpec && rowSpec.__rootMatchSettingsPresetKey });
    modal.body.appendChild(rendered);

    try { modal.node.hidden = false; } catch (_) { }
    try { modal.node.setAttribute("aria-hidden", "false"); } catch (_) { }
    try { modal.node.style.display = "flex"; } catch (_) { }
    try { modal.node.style.pointerEvents = "auto"; } catch (_) { }
    try { document.documentElement.classList.add("mgps-modal-open"); } catch (_) { }
    try { document.body.classList.add("mgps-modal-open"); } catch (_) { }

    const runLayout = () => {
      try {
        rendered.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
          rowEl.dataset.rowDisplayType = "wrap";
          applyFitRow(rowEl);
        });
        applySwatchPopupGrid(rendered, meta);
      } catch (_) { }
    };

    try {
      requestAnimationFrame(() => {
        runLayout();
        requestAnimationFrame(() => {
          runLayout();
          window.setTimeout(runLayout, 30);
        });
      });
    } catch (_) { }
  }

  function renderRows(rows, opts = {}) {
    const rowsRoot = document.createElement("div");
    rowsRoot.className = "mgps-rows";
    if (opts.inModal) rowsRoot.classList.add("is-in-modal");

    for (const rawRow of (Array.isArray(rows) ? rows : [])) {
      const rowSpec = normalizeRow(rawRow, { matchSettingsPresetKey: opts && opts.matchSettingsPresetKey });
      rowSpec.__rootAppearance = opts.appearance || null;
      rowSpec.__rootSelectedAppearance = opts.selectedAppearance || null;
      rowSpec.__rootCornerRadiusPx = Number.isFinite(Number(opts.cornerRadiusPx)) ? Number(opts.cornerRadiusPx) : null;
      rowSpec.__rootMatchSettingsPresetKey = String(opts.matchSettingsPresetKey || "").trim();
      rowSpec.__rootTextBehaviorOverride = String(opts.textBehaviorOverride || "").trim().toLowerCase();
      rowSpec.__forceRootAppearance = !!((opts && opts.forceRootAppearance) || rowSpec.__force_root_appearance);
      rowSpec.__forceRootBorderAppearance = !!(opts && opts.forceRootBorderAppearance);
      rowSpec.__appearance = rowSpec.__appearance || rowSpec.appearance || null;
      rowSpec.__selectedAppearance = rowSpec.__selectedAppearance || rowSpec.selected_appearance || null;
      rowSpec.__cornerRadiusPx = Number.isFinite(Number(rowSpec.__rootCornerRadiusPx)) ? Number(rowSpec.__rootCornerRadiusPx) : rowSpec.__cornerRadiusPx;
      if (!Number.isFinite(Number(rowSpec.__cornerRadiusPx))) rowSpec.__cornerRadiusPx = rowSpec.corner_radius_px;
      if (rowSpec.__selectedAppearance && rowSpec.__appearance && rowSpec.__appearance.border_scope) {
        rowSpec.__selectedAppearance.border_scope = rowSpec.__selectedAppearance.border_scope || rowSpec.__appearance.border_scope;
      }
      const rowWrap = document.createElement("section");
      rowWrap.className = "mgps-row";
      rowWrap.style.width = "100%";
      rowWrap.style.maxWidth = "100%";
      rowWrap.style.minWidth = "0";
      rowWrap.style.boxSizing = "border-box";
      if (rowSpec.margin_top > 0) rowWrap.style.marginTop = rowSpec.margin_top + "px";
      if (rowSpec.margin_bottom > 0) rowWrap.style.marginBottom = rowSpec.margin_bottom + "px";
      rowWrap.dataset.rowJustify = String(rowSpec.row_justify || "center");

      const heading = buildRowHeading(rowSpec);
      if (heading && !rowSpec.preset_button) rowWrap.appendChild(heading);

      const hasCustom = renderCustomRow(rowSpec, rowWrap);
      const allItems = normalizeItems(rowSpec.videos || []);
      const popupTriggerIndex = allItems.findIndex((it) => String(it?.type || "").trim().toLowerCase() === "swatch_popup_trigger");
      const popupTrigger = popupTriggerIndex >= 0 ? allItems[popupTriggerIndex] : null;
      const items = popupTriggerIndex >= 0
        ? allItems.slice(0, popupTriggerIndex).filter((it) => String(it?.type || "").trim().toLowerCase() !== "swatch_popup_trigger")
        : allItems.filter((it) => String(it?.type || "").trim().toLowerCase() !== "swatch_popup_trigger");

        if (rowSpec.preset_button) {
          rowWrap.classList.add("is-preset-button");
          rowWrap.style.overflow = "visible";
          rowWrap.style.paddingLeft = "";
          rowWrap.style.paddingRight = "";
          rowWrap.style.marginBottom = "";
          const presetButton = makePresetButton(rowSpec);
          rowWrap.appendChild(presetButton);
          const presetShadowSize = clampNumber(rowSpec.preset_button_shadow_size, 0, 60, 0);
          if (presetShadowSize > 0) {
            const spacer = document.createElement("div");
            spacer.setAttribute("aria-hidden", "true");
            spacer.style.width = "100%";
            spacer.style.height = presetShadowSize + "px";
            spacer.style.pointerEvents = "none";
            spacer.style.flex = "0 0 auto";
            rowWrap.appendChild(spacer);
          }
          rowsRoot.appendChild(rowWrap);
          continue;
        }

      if (items.length) {
        const rowDisplayTypeDesktop = String(rowSpec.row_display_type_desktop || rowSpec.row_display_type || "scrollable").trim().toLowerCase() || "scrollable";
        const rowDisplayTypeMobile = String(rowSpec.row_display_type_mobile || rowDisplayTypeDesktop).trim().toLowerCase() || rowDisplayTypeDesktop;
        const rowDisplayType = window.innerWidth <= 768 ? rowDisplayTypeMobile : rowDisplayTypeDesktop;

        const viewport = document.createElement("div");
        viewport.className = "mgps-row-viewport";
        viewport.dataset.rowDisplayType = rowDisplayType;
        viewport.dataset.rowDisplayTypeMobile = rowDisplayTypeMobile;
        viewport.dataset.rowDisplayTypeDesktop = rowDisplayTypeDesktop;
        viewport.style.width = "100%";
        viewport.style.maxWidth = "100%";
        viewport.style.minWidth = "0";
        viewport.style.boxSizing = "border-box";

        const rowEl = document.createElement("div");
        rowEl.className = "mgps-thumb-row";
        rowEl.dataset.swatchRow = "true";
        rowEl.dataset.fitRow = rowSpec.fit_row ? "true" : "false";
        rowEl.dataset.rowDisplayType = rowDisplayType;
        rowEl.dataset.rowDisplayTypeMobile = rowDisplayTypeMobile;
        rowEl.dataset.rowDisplayTypeDesktop = rowDisplayTypeDesktop;
        rowEl.dataset.morePopupText = String(rowSpec.more_popup_text || "More");
        rowEl.dataset.rowJustify = String(rowSpec.row_justify || "center");
        rowEl.dataset.imgRatio = String(rowSpec.img_ratio || "1:1");
        rowEl.dataset.rowHeight = String(Number(rowSpec.row_height_desktop || rowSpec.row_height || 0) || 0);
        rowEl.dataset.rowHeightMobile = String(Number(rowSpec.row_height_mobile || 0) || 0);
        rowEl.dataset.rowHeightDesktop = String(Number(rowSpec.row_height_desktop || rowSpec.row_height || 0) || 0);
        rowEl.dataset.swatchesPerRowMobile = String(Math.max(0, Number(rowSpec.swatches_per_row_mobile || 0) || 0));
        rowEl.dataset.swatchesPerRowDesktop = String(Math.max(0, Number(rowSpec.swatches_per_row_desktop || rowSpec.swatches_per_row || 0) || 0));
        rowEl.dataset.paddingBetweenRowsMobile = String(Math.max(0, Number(rowSpec.padding_between_rows_mobile || 0) || 0));
        rowEl.dataset.paddingBetweenRowsDesktop = String(Math.max(0, Number(rowSpec.padding_between_rows_desktop || rowSpec.padding_between_rows || 0) || 0));
        rowEl.dataset.swatchesPerRow = rowEl.dataset.swatchesPerRowDesktop;
        rowEl.style.overflow = "visible";
        const _mgpsRowCornerRadius = (() => { const raw = (rowSpec.__cornerRadiusPx ?? rowSpec.corner_radius_px); const v = Number(raw); return Number.isFinite(v) && v >= 0 ? v : 12; })();
        rowEl.dataset.cornerRadiusPx = String(_mgpsRowCornerRadius);
        rowEl.style.setProperty("--mgps-row-corner-radius", String(_mgpsRowCornerRadius) + "px");
        rowEl.__rowSpec = rowSpec;
        rowEl.style.setProperty("--mgps-row-justify", String(rowSpec.row_justify || "center"));
        rowEl.style.setProperty("--mgps-row-aspect", (() => {
          const ratio = parseImgRatio(rowSpec.img_ratio || "1:1");
          return ratio.w + " / " + ratio.h;
        })());
        const initialRowHeight = (window.innerWidth <= 768)
          ? (Number(rowSpec.row_height_mobile || 0) || Number(rowSpec.row_height_desktop || rowSpec.row_height || 0) || 0)
          : (Number(rowSpec.row_height_desktop || rowSpec.row_height || 0) || 0);
        if (initialRowHeight > 0) rowEl.style.setProperty("--mgps-row-height", initialRowHeight + "px");
        const initialPaddingBetweenRows = (window.innerWidth <= 768)
          ? (Number(rowSpec.padding_between_rows_mobile || 0) || Number(rowSpec.padding_between_rows_desktop || rowSpec.padding_between_rows || 0) || 0)
          : (Number(rowSpec.padding_between_rows_desktop || rowSpec.padding_between_rows || 0) || 0);
        rowEl.style.setProperty("--mgps-padding-between-rows", initialPaddingBetweenRows + "px");

        items.forEach((item) => rowEl.appendChild(makeSwatchCard(item, rowSpec, { inModal: !!opts.inModal })));
        applyRowCornerRadius(rowEl);
        viewport.appendChild(rowEl);
        rowWrap.appendChild(viewport);

        if (popupTrigger && allItems.length > items.length) {
          const popupWrap = document.createElement("div");
          popupWrap.className = "mgps-swatch-popup-wrap";
          const popupJustify = String(popupTrigger?.button_justify || "left").trim().toLowerCase() || "left";
          popupWrap.dataset.buttonJustify = popupJustify;
          popupWrap.setAttribute("data-button-justify", popupJustify);
          const popupMarginTop = Math.max(0, Number(popupTrigger?.margin_top_px || 10) || 10);
          popupWrap.style.display = "flex";
          popupWrap.style.width = "100%";
          popupWrap.style.maxWidth = "100%";
          popupWrap.style.minWidth = "0";
          popupWrap.style.marginTop = popupMarginTop + "px";
          popupWrap.style.justifyContent =
            popupJustify === "center" ? "center" :
              popupJustify === "right" ? "flex-end" :
                "flex-start";
          popupWrap.appendChild(makeSwatchPopupButton(
            popupTrigger,
            rowSpec,
            allItems.filter((it) => String(it?.type || "").trim().toLowerCase() !== "swatch_popup_trigger")
          ));
          rowWrap.appendChild(popupWrap);
        }
      }

      if (heading || hasCustom || items.length) rowsRoot.appendChild(rowWrap);
    }

    return rowsRoot;
  }


  function applyRowCornerRadius(rowEl) {
    if (!rowEl) return;
    const rowSpec = rowEl.__rowSpec || {};
    const radius = resolvedRowCornerRadiusPx(rowSpec, (() => { const v = Number(rowEl.dataset.cornerRadiusPx); return Number.isFinite(v) && v >= 0 ? v : 12; })());

    try {
      rowEl.dataset.cornerRadiusPx = String(radius);
      rowEl.style.setProperty("--mgps-row-corner-radius", radius + "px");
    } catch (_) { }

    rowEl.querySelectorAll(":scope > .mgps-thumb").forEach((card) => {
      try {
        card.style.setProperty("--mgps-corner-radius", radius + "px");
      } catch (_) { }

      const slot = card.querySelector(".mgps-thumb-slot");
      if (slot) {
        try {
          slot.style.borderRadius = radius + "px";
          slot.style.overflow = "hidden";
          slot.style.setProperty("--mgps-corner-radius", radius + "px");
          if (radius === 0) {
            slot.style.borderTopLeftRadius = "0";
            slot.style.borderTopRightRadius = "0";
            slot.style.borderBottomLeftRadius = "0";
            slot.style.borderBottomRightRadius = "0";
          }
        } catch (_) { }
      }

      const imgWrap = card.querySelector(".mgps-img-wrap");
      if (imgWrap) {
        try {
          imgWrap.style.borderRadius = radius + "px";
          imgWrap.style.overflow = "hidden";
          imgWrap.style.setProperty("--mgps-corner-radius", radius + "px");
          if (radius === 0) {
            imgWrap.style.borderTopLeftRadius = "0";
            imgWrap.style.borderTopRightRadius = "0";
            imgWrap.style.borderBottomLeftRadius = "0";
            imgWrap.style.borderBottomRightRadius = "0";
          }
        } catch (_) { }
      }

      const block = card.querySelector(".mgps-thumb-block");
      if (block) {
        try {
          setStyleImportant(block, "border-radius", "0");
        } catch (_) { }
      }
    });
  }

  function applyEditorPreviewSelection(root) {
    if (!root || !window.Shopify || !window.Shopify.designMode) return;
    try {
      root.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
        const cards = Array.from(rowEl.querySelectorAll(":scope > .mgps-thumb[data-kind='product']"));
        if (!cards.length) return;
        const hasCurrent = cards.some((card) => String(card.dataset.currentProduct || "") === "true");
        if (hasCurrent) return;

        const card = cards[0];
        card.dataset.currentProduct = "true";

        const block = card.querySelector(".mgps-thumb-block");
        const slot = card.querySelector(".mgps-thumb-slot");
        const imgWrap = card.querySelector(".mgps-img-wrap");
        const bottom = card.querySelector(".mgps-card-bottom");
        const img = imgWrap && imgWrap.querySelector ? imgWrap.querySelector("img") : null;
        if (block && block.tagName === "A") {
          try {
            block.removeAttribute("href");
            block.removeAttribute("target");
            block.setAttribute("aria-current", "page");
            block.setAttribute("aria-disabled", "true");
          } catch (_) { }
        }
        applySwatchAppearance(card, block, slot, imgWrap, bottom, img, rowEl.__rowSpec || {}, true);
      });
      root.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
        applyRowTextSizing(rowEl);
      });
    } catch (_) { }
  }

  function relayoutRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(".mgps-thumb-row").forEach((rowEl) => {
      applyFitRow(rowEl);
      applyRowCornerRadius(rowEl);
      try {
        const rowSpec = rowEl.__rowSpec || {};
        rowEl.querySelectorAll(":scope > .mgps-thumb").forEach((card) => {
          applySwatchAppearance(
            card,
            card.querySelector(".mgps-thumb-block"),
            card.querySelector(".mgps-thumb-slot"),
            card.querySelector(".mgps-img-wrap"),
            card.querySelector(".mgps-card-bottom"),
            card.querySelector(".mgps-img-wrap img"),
            rowSpec,
            String(card.dataset.currentProduct || "") === "true"
          );
        });
      } catch (_) { }
    });
    try { applyPresetButtonTextFit(root); } catch (_) { }
  }

  function renderRoot(root) {
    if (!root) return;
    const setName = String(root.getAttribute("data-mg-set") || root.getAttribute("data-vimeo-set") || "").trim();
    if (!setName) {
      root.innerHTML = "";
      return;
    }

    const rootAppearance = parseRootSwatchAppearance(root);
    const explicitRootAppearance = rootHasExplicitAppearance(root);
    const explicitRootBorderAppearance = rootHasExplicitBorderAppearance(root);
    const matchedSettingsKey = getDataAttr(root, "data-mgps-match-settings-preset");
    const resolvedMeta = matchedSettingsKey
      ? resolveSetMeta(matchedSettingsKey, new Set())
      : (explicitRootAppearance ? {} : resolveSetMeta(setName, new Set()));
    const metaAppearance = isNonEmptyObject(resolvedMeta.appearance)
      ? normalizeSwatchAppearance(resolvedMeta.appearance, "image")
      : null;
    const metaSelectedAppearance = isNonEmptyObject(resolvedMeta.selected_appearance)
      ? normalizeSwatchAppearance(resolvedMeta.selected_appearance, (metaAppearance && metaAppearance.border_scope) || "image")
      : null;
    if (metaSelectedAppearance && metaAppearance && metaAppearance.border_scope) {
      metaSelectedAppearance.border_scope = metaSelectedAppearance.border_scope || metaAppearance.border_scope;
    }
    const textBehaviorOverride = rootTextBehaviorOverride(root);
    if (textBehaviorOverride) {
      if (metaAppearance) metaAppearance.text_behavior = textBehaviorOverride;
      if (metaSelectedAppearance) metaSelectedAppearance.text_behavior = textBehaviorOverride;
      rootAppearance.appearance.text_behavior = textBehaviorOverride;
      rootAppearance.selectedAppearance.text_behavior = textBehaviorOverride;
    }
    const metaCorner = (() => {
      const v = Number(resolvedMeta.corner_radius_px);
      return Number.isFinite(v) && v >= 0 ? v : null;
    })();

    const mergedRootAppearance = metaAppearance
      ? (
        explicitRootAppearance
          ? mergeSwatchAppearance(metaAppearance, rootAppearance.appearance, metaAppearance.border_scope || "image")
          : normalizeSwatchAppearance(metaAppearance, metaAppearance.border_scope || "image")
      )
      : rootAppearance.appearance;
    const mergedRootSelectedAppearance = metaSelectedAppearance
      ? (
        explicitRootAppearance
          ? mergeSwatchAppearance(metaSelectedAppearance, rootAppearance.selectedAppearance, (mergedRootAppearance && mergedRootAppearance.border_scope) || "image")
          : normalizeSwatchAppearance(metaSelectedAppearance, (mergedRootAppearance && mergedRootAppearance.border_scope) || "image")
      )
      : rootAppearance.selectedAppearance;
    if (mergedRootSelectedAppearance && mergedRootAppearance && mergedRootAppearance.border_scope) {
      mergedRootSelectedAppearance.border_scope = mergedRootSelectedAppearance.border_scope || mergedRootAppearance.border_scope;
    }

    root.__mgpsAppearance = mergedRootAppearance || rootAppearance.appearance;
    root.__mgpsSelectedAppearance = mergedRootSelectedAppearance || rootAppearance.selectedAppearance;
    root.__mgpsCornerRadiusPx = explicitRootAppearance ? rootAppearance.cornerRadiusPx : (metaCorner != null ? metaCorner : rootAppearance.cornerRadiusPx);

    const rows = resolveSet(setName, new Set(), { matchSettingsPresetKey: matchedSettingsKey });
    root.__mgpsResolvedRows = cloneDeep(rows);
    root.innerHTML = "";

    if (isDebugAppearanceEnabled() && typeof console !== "undefined" && console.info) {
      try {
        const firstRow = Array.isArray(rows) && rows.length ? rows[0] : null;
        const debugPayload = {
          setName,
          matchedSettingsKey,
          explicitRootAppearance,
          explicitRootBorderAppearance,
          rootAppearance: root.__mgpsAppearance,
          rootSelectedAppearance: root.__mgpsSelectedAppearance,
          firstRowAppearance: firstRow && firstRow.appearance,
          firstRowSelectedAppearance: firstRow && firstRow.selected_appearance,
          firstRowForceRootAppearance: !!(firstRow && firstRow.__force_root_appearance)
        };
        console.info("[MGPS][appearance-debug]", debugPayload);
        mountAppearanceDebugBadge(debugPayload);
      } catch (_) { }
    }

    if (!rows.length) {
      if (window.Shopify && window.Shopify.designMode) {
        const empty = document.createElement("div");
        empty.className = "mgps-empty";
        empty.innerHTML = 'No swatch rows found for set <code>' + escapeHtml(setName) + '</code>.';
        root.appendChild(empty);
      }
      return;
    }

    root.appendChild(renderRows(rows, {
      appearance: root.__mgpsAppearance,
      selectedAppearance: root.__mgpsSelectedAppearance,
      cornerRadiusPx: root.__mgpsCornerRadiusPx,
      textBehaviorOverride: textBehaviorOverride,
      matchSettingsPresetKey: matchedSettingsKey,
      forceRootAppearance: false,
      forceRootBorderAppearance: explicitRootBorderAppearance,
      root: root
    }));
    applyEditorPreviewSelection(root);
    try {
      requestAnimationFrame(() => {
        try { applyPresetButtonTextFit(root); } catch (_) { }
      });
    } catch (_) { }
    requestAnimationFrame(() => relayoutRoot(root));
  }

  function initRoot(root) {
    if (!root || root.__mgpsInit) return;
    root.__mgpsInit = true;

    const cleanupFns = [];

    renderRoot(root);

    if (typeof ResizeObserver === "function") {
      const ro = new ResizeObserver(() => {
        relayoutRoot(root);
      });
      ro.observe(root);
      cleanupFns.push(() => {
        try { ro.disconnect(); } catch (_) { }
      });
    } else {
      const onResize = () => relayoutRoot(root);
      window.addEventListener("resize", onResize);
      cleanupFns.push(() => window.removeEventListener("resize", onResize));
    }

    try {
      if (document.fonts) {
        const onFontsDone = () => relayoutRoot(root);
        if (document.fonts.ready && typeof document.fonts.ready.then === "function") {
          document.fonts.ready.then(onFontsDone).catch(() => { });
        }
        if (document.fonts.addEventListener) {
          document.fonts.addEventListener("loadingdone", onFontsDone);
          cleanupFns.push(() => {
            try { document.fonts.removeEventListener("loadingdone", onFontsDone); } catch (_) { }
          });
        }
      }
    } catch (_) { }

    root.__mgpsDestroy = function () {
      cleanupFns.forEach((fn) => {
        try { fn(); } catch (_) { }
      });
      root.innerHTML = "";
      try { delete root.__mgpsInit; } catch (_) { }
      try { delete root.__mgpsDestroy; } catch (_) { }
    };
  }

  function stripInternalsForExport(value) {
    const replacer = (key, currentValue) => {
      if (key && key.startsWith("__")) return undefined;
      if (typeof currentValue === "function") return undefined;
      if (currentValue && typeof currentValue === "object") {
        try {
          if (currentValue === window || currentValue === document) return undefined;
          if (currentValue.nodeType) return undefined;
        } catch (_) { }
      }
      return currentValue;
    };

    try {
      return JSON.parse(JSON.stringify(value, replacer));
    } catch (_) {
      return cloneDeep(value);
    }
  }

  function prepareRowsForSetExport(rows, rootOrMeta) {
    const cleaned = stripInternalsForExport(rows);
    const normalizedRows = Array.isArray(cleaned) ? cleaned : coerceToRows(cleaned);
    const exportMeta = rootOrMeta && rootOrMeta.nodeType ? readRootAppearanceMeta(rootOrMeta) : (rootOrMeta || {});
    const matchedSettingsKey = collapseWhitespace(exportMeta.match_settings_preset_key || exportMeta.matchPresetSettingsKey || "");

    return normalizedRows.map((row) => {
      const copy = Object.assign({}, row || {});
      const items = normalizeItems(rowItems(copy));

      copy.swatches = items;

      delete copy.videos;
      delete copy.items;
      delete copy.cards;
      delete copy.corner_radius_px;
      delete copy.appearance;
      delete copy.selected_appearance;
      delete copy.swatch_appearance;
      delete copy.swatch_selected_appearance;
      delete copy.match_settings_preset_key;
      delete copy.matchPresetSettingsKey;
      if (matchedSettingsKey) {
        delete copy.heading_justify;
        delete copy.img_ratio;
        delete copy.row_height;
        delete copy.row_height_mobile;
        delete copy.row_height_desktop;
        delete copy.fit_row;
        delete copy.row_display_type;
        delete copy.row_display_type_mobile;
        delete copy.row_display_type_desktop;
        delete copy.more_popup_text;
        delete copy.margin_top;
        delete copy.margin_bottom;
        delete copy.row_justify;
        delete copy.swatches_per_row_mobile;
        delete copy.swatches_per_row_desktop;
        delete copy.swatches_per_row;
        delete copy.collapsed;
        delete copy.show_more_text;
        delete copy.show_less_text;
        delete copy.row_toggle_border_style;
        delete copy.hide_cta_buttons;
        delete copy.end_behavior_override;
      }

      copy.swatches = items.map((item) => {
        const itemCopy = Object.assign({}, item || {});
        const thumbMode = String(itemCopy.thumb_mode || itemCopy.thumbMode || "").trim().toLowerCase();
        const savedProductImageUrl = collapseWhitespace(itemCopy.product_image_url || itemCopy.productImageUrl || "");
        if (thumbMode !== "override" && savedProductImageUrl) {
          delete itemCopy.thumbnail;
          delete itemCopy.image;
          delete itemCopy.img;
          delete itemCopy.product_image_id;
        }
        delete itemCopy.price;
        delete itemCopy.price_num;
        delete itemCopy.match_settings_preset_key;
        delete itemCopy.matchPresetSettingsKey;
        if (matchedSettingsKey) {
          delete itemCopy.show_price;
          delete itemCopy.show_reviews;
          delete itemCopy.show_shop_button;
          delete itemCopy.buttons_over_image;
          delete itemCopy.swatch_image_zoom;
          delete itemCopy.swatchImageZoom;
          delete itemCopy.randomize_zoom_area;
          delete itemCopy.randomizeZoomArea;
          delete itemCopy.scale;
          delete itemCopy.product_image_scale;
          delete itemCopy.vjust;
          delete itemCopy.html_desc;
          delete itemCopy.desc_html;
          delete itemCopy.margin_top;
          delete itemCopy.margin_bottom;
          delete itemCopy.open_set_key;
          delete itemCopy.learn_more_text;
          delete itemCopy.popup_swatches_per_row_mobile;
          delete itemCopy.popup_swatches_per_row_desktop;
        }
        return itemCopy;
      });

      return copy;
    });
  }

  function readRootAppearanceMeta(root) {
    if (!root) return { appearance: {}, selected_appearance: {}, corner_radius_px: 12 };
    const matchedSettingsKey = collapseWhitespace(root.getAttribute("data-mgps-match-settings-preset"));
    if (matchedSettingsKey) {
      return {
        match_settings_preset_key: matchedSettingsKey
      };
    }
    const parsed = parseRootSwatchAppearance(root);
    const cornerRaw = root.getAttribute("data-mgps-corner-radius");
    const corner = Number(cornerRaw);
    return {
      appearance: Object.assign({}, parsed.appearance || {}),
      selected_appearance: Object.assign({}, parsed.selectedAppearance || {}),
      corner_radius_px: Number.isFinite(corner) && corner >= 0 ? corner : 12
    };
  }

  function normalizeMetaForExport(meta) {
    const source = meta && typeof meta === "object" ? meta : {};
    const matchedSettingsKey = collapseWhitespace(source.match_settings_preset_key || source.matchPresetSettingsKey || "");
    if (matchedSettingsKey) {
      return {
        match_settings_preset_key: matchedSettingsKey
      };
    }
    return Object.assign({}, source);
  }

  function prepareSetPayloadForExport(root, rows) {
    const meta = normalizeMetaForExport(readRootAppearanceMeta(root));
    return {
      meta: meta,
      rows: prepareRowsForSetExport(rows, meta)
    };
  }

  function rawRowsForExport(key, fallbackRows) {
    const setKey = collapseWhitespace(key);
    if (setKey && Object.prototype.hasOwnProperty.call(R.__rawSpecs, setKey)) {
      return coerceToRows(R.__rawSpecs[setKey] && R.__rawSpecs[setKey].rows);
    }

    const store = getSetStore();
    if (setKey && Object.prototype.hasOwnProperty.call(store, setKey)) {
      const value = store[setKey];
      const payload = getSetPayload(value);
      return coerceToRows(payload ? payload.rows : value);
    }

    return Array.isArray(fallbackRows) ? cloneDeep(fallbackRows) : [];
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise((resolve, reject) => {
      try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "readonly");
        ta.style.position = "fixed";
        ta.style.top = "-1000px";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  function formatSetExport(key, rows, root) {
    const json = JSON.stringify(prepareSetPayloadForExport(root, rows), null, 2);
    return [
      "// MG Product Swatches export: " + key,
      "window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};",
      "window.MG_SWATCH_SETS[" + JSON.stringify(key) + "] = " + json + ";"
    ].join("\n");
  }

  function formatSetInnerExport(key, rows, root) {
    const json = JSON.stringify(prepareSetPayloadForExport(root, rows), null, 2);
    return "window.MG_SWATCH_SETS[" + JSON.stringify(String(key || "")) + "] = " + json + ";";
  }

  function collectRootMetaMap(context) {
    const scope = context && context.querySelectorAll ? context : document;
    const map = Object.create(null);
    getRoots(scope).forEach((root) => {
      try {
        const key = collapseWhitespace(root && root.getAttribute && root.getAttribute("data-mg-set"));
        if (!key) return;
        map[key] = readRootAppearanceMeta(root);
      } catch (_) { }
    });
    return map;
  }

  function formatAllExport(context) {
    try { buildFromDom(context && context.querySelectorAll ? context : document); } catch (_) { }
    const store = getSetStore();
    const rootMetaMap = collectRootMetaMap(context);
    const cleaned = Object.create(null);
    Object.keys(store).sort().forEach((key) => {
      const payload = getSetPayload(store[key]);
      const meta = normalizeMetaForExport(rootMetaMap[key] || getSetMeta(store[key]) || {});
      cleaned[key] = payload
        ? { meta: meta, rows: prepareRowsForSetExport(coerceToRows(payload.rows), meta) }
        : { meta: meta, rows: prepareRowsForSetExport(coerceToRows(store[key]), meta) };
    });
    return [
      "// MG Product Swatches export: all sets",
      "window.MG_SWATCH_SETS = " + JSON.stringify(cleaned, null, 2) + ";"
    ].join("\n");
  }

  function mountExportUI(exportBox) {
    if (!exportBox || exportBox.__mgpsMounted) return;
    exportBox.__mgpsMounted = true;

    const sourceSet = String(exportBox.getAttribute("data-source-set") || "").trim();
    exportBox.innerHTML = [
      '<button class="mgps-export__toggle" type="button" data-mgps-toggle>Export JSON</button>',
      '<div class="mgps-export__panel" data-mgps-panel hidden>',
      '  <div class="mgps-export__bar">',
      '    <span class="mgps-export__label">Set:</span>',
      '    <input class="mgps-export__input" data-mgps-set />',
      '    <button class="mgps-export__btn" type="button" data-mgps-copy-all>Copy All</button>',
      '    <button class="mgps-export__btn" type="button" data-mgps-copy-set>Copy Media Set</button>',
      '    <button class="mgps-export__btn mgps-export__btn--close" type="button" data-mgps-close aria-label="Close">✕</button>',
      '  </div>',
      '  <textarea class="mgps-export__textarea" data-mgps-out rows="14" readonly></textarea>',
      '</div>'
    ].join("");

    const toggle = exportBox.querySelector("[data-mgps-toggle]");
    const panel = exportBox.querySelector("[data-mgps-panel]");
    const close = exportBox.querySelector("[data-mgps-close]");
    const copyAll = exportBox.querySelector("[data-mgps-copy-all]");
    const copySet = exportBox.querySelector("[data-mgps-copy-set]");
    const out = exportBox.querySelector("[data-mgps-out]");
    const setInput = exportBox.querySelector("[data-mgps-set]");
    if (setInput) setInput.value = sourceSet;

    function currentKey() {
      const raw = collapseWhitespace(setInput ? setInput.value : sourceSet);
      return raw || sourceSet;
    }

    function currentRoot() {
      const explicitRootId = String(exportBox.getAttribute("data-mgps-root-id") || "").trim();
      if (explicitRootId) {
        const linked = document.getElementById(explicitRootId);
        if (linked) return linked;
      }
      let root = exportBox.closest('.mg-product-swatches, .mg-swatch-presets, [data-mg-set]');
      if (root) return root;
      let probe = exportBox.previousElementSibling;
      while (probe) {
        if (probe.matches && probe.matches('.mg-product-swatches, .mg-swatch-presets, [data-mg-set]')) return probe;
        probe = probe.previousElementSibling;
      }
      probe = exportBox.parentElement;
      while (probe) {
        const found = probe.querySelector && probe.querySelector('.mg-product-swatches, .mg-swatch-presets, [data-mg-set]');
        if (found) return found;
        probe = probe.parentElement;
      }
      return null;
    }

    function currentRows() {
      const key = currentKey();
      const root = currentRoot();
      try { buildFromDom(document); } catch (_) { }
      const raw = rawRowsForExport(key, []);
      if (raw && raw.length) return raw;
      const resolved = key ? resolveSet(key, new Set()) : [];
      if (resolved && resolved.length) return resolved;
      if (root && Array.isArray(root.__mgpsResolvedRows) && root.__mgpsResolvedRows.length) return cloneDeep(root.__mgpsResolvedRows);
      return [];
    }

    function refreshTextarea() {
      const key = currentKey();
      out.value = key ? formatSetExport(key, currentRows(), currentRoot()) : "";
    }

    toggle.addEventListener("click", () => {
      const isHidden = !!panel.hidden;
      panel.hidden = !isHidden;
      if (isHidden) refreshTextarea();
    });

    close.addEventListener("click", () => {
      panel.hidden = true;
    });

    if (setInput) {
      setInput.addEventListener("input", refreshTextarea);
      setInput.addEventListener("change", refreshTextarea);
    }

    copySet.addEventListener("click", async () => {
      const key = currentKey();
      out.value = key ? formatSetInnerExport(key, currentRows(), currentRoot()) : "";
      try {
        await mgSelectAndCopyText(out);
        copySet.textContent = "Copied";
        window.setTimeout(() => { copySet.textContent = "Copy Media Set"; refreshTextarea(); }, 1200);
      } catch (_) { }
    });

    copyAll.addEventListener("click", async () => {
      out.value = formatAllExport(document);
      try {
        await mgSelectAndCopyText(out);
        copyAll.textContent = "Copied";
        window.setTimeout(() => { copyAll.textContent = "Copy All"; refreshTextarea(); }, 1200);
      } catch (_) { }
    });

    refreshTextarea();
  }

  function initAll(context) {
    getRoots(context).forEach(initRoot);
    getExportBoxes(context).forEach(mountExportUI);
  }

  R.refresh = function (context) {
    const scope = context && context.querySelectorAll ? context : document;
    getRoots(scope).forEach((root) => {
      try {
        if (typeof root.__mgpsDestroy === "function") root.__mgpsDestroy();
      } catch (_) { }
    });
    try { buildFromDom(document); } catch (_) { }
    initAll(scope);
  };

  R.destroy = function (context) {
    const scope = context && context.querySelectorAll ? context : document;
    getRoots(scope).forEach((root) => {
      try {
        if (typeof root.__mgpsDestroy === "function") root.__mgpsDestroy();
      } catch (_) { }
    });
    try {
      if (R.__modal && typeof R.__modal.close === "function") {
        R.__modal.close();
      }
    } catch (_) { }
  };

  ready(() => {
    try { buildFromDom(document); } catch (_) { }
    initAll(document);
  });

  document.addEventListener("shopify:section:load", (event) => {
    if (!event || !event.target) return;
    R.refresh(event.target);
  });

  document.addEventListener("shopify:section:reorder", (event) => {
    if (!event || !event.target) return;
    R.refresh(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    if (!event || !event.target) return;
    R.destroy(event.target);
  });
})();
